/**
    This file is auto-generated by Reactor, do not modify
    @reactor-ignore
*/
import type { WebFooterItem } from "../packages/web/model/WebFooter"
import type { WebMenuItem } from "../packages/web/model/WebMenu"
import type { Section } from "../packages/editing/Section"
import type { Locale } from "../packages/localization/Locale"
import type { StudioFileInfo } from "./API/DocumentPageAPI"
import type { StudioPropOptions } from "./API/DocumentPageAPI"
import type { StudioTypeExtensions } from "./API/DocumentPageAPI"
import type { StudioPropWidget } from "./API/DocumentPageAPI"
import type { StudioRefTypes } from "./API/DocumentPageAPI"
import type { WidgetMap } from "../packages/widgets/Widget"
import type { Chip } from "../packages/widgets/Chip"
import type { ClientEffect } from "../packages/widgets/client-effects/ClientEffect"
import type { PaymentAmount } from "../packages/adyen/types/dtos"
import type { PaymentChannel } from "../packages/adyen/types/dtos"
import type { LocaleKey } from "../packages/localization/Locale"
import type { GetPaymentStatusDto } from "../packages/adyen/types/dtos"
import type { Markdown } from "../reactor/Types/Primitives/Markdown"
import type { Timestamp } from "../reactor/Types/Primitives/DateTime"
import type { Email } from "../reactor/Types/Primitives/Email"
import type { WidgetActionResponse } from "../packages/widgets/WidgetRequest"
import type { WidgetActionRequest } from "../packages/widgets/WidgetRequest"
import type { WidgetResponse } from "../packages/widgets/WidgetRequest"
import type { WidgetRequest } from "../packages/widgets/WidgetRequest"
import type { Url } from "../reactor/Types/Primitives/Url"
import type { Localized } from "../packages/localization/Localized"
import type { TemplateDesc } from "../reactor/ReflectionInfo"
import type { Widget } from "../packages/widgets/Widget"
import { SSRHook } from "../packages/ssr/SSRHook"
import type { Uuid } from "../reactor/Types/Primitives/Uuid"
import { server } from "../server"
type Headers = { [name: string]: string }
type CallOptions = {
    /**
     * The maximum number of times to retry the operation before giving up.
     *
     *  Defaults to 1 (one attempt in addition to the initial attempt).
     *
     *  The operation will only be retried if a handler plugin understood the
     *  error, was able to correct for it, and returned `{ retry: true }`.
     *
     *  The typical use case for this is to retry a request that failed
     *  due to e.g. an expired access token, that was successfully refreshed by a handler.
     *
     *  Other types of handler plugins may also be installed to deal with
     *  other types of errors which supports retrying.
     */
    maxRetries?: number

    /**
     * Override the default baseUrl for this request.
     */
    baseUrl?: string
}
export const defaults: {
    baseUrl: string
    fetch: typeof fetch
    headers: Headers
} = {
    baseUrl: server(),
    fetch(input: any, init: any) {
        // fetch() really wants to be called like this, treating it as a
        // value won't work
        return fetch(input, init)
    },
    headers: {
        "Content-Type": "application/json",
    },
}
export type File<mimeType = any> = string
// Creates an adapter so browser and node streams can be used interchangeably
async function* readStream(stream: any) {
    const reader = stream.getReader()
    while (true) {
        const { done, value } = await reader.read()
        if (done) break
        yield value
    }
}
export type PostDocumentObjectViewRequestBodyDto = {
    objects: {
        /** If the type is a reflected type, use this.*/ typeAlias?: string
        /** The actual object, or the primary key of the object.*/
        obj?: any
    }[]
    /** The current state of the document being edited that the views should be rendered in the
context of.*/
    document?: any
}
export type PostDocumentObjectViewDto = { views: Widget[] }
/** Computes display views for the given objects, for use in studio. */
SSRHook.clientEndpoints.push({ name: "postDocumentObjectView", func: postDocumentObjectView })
export async function postDocumentObjectView(
    body: PostDocumentObjectViewRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostDocumentObjectViewDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/document/object/views`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type BadRequest = {
    /** The type of this error, can be used for union discrimination*/ type: "BadRequest"
    status: number
    detail: string
    stack?: string
}
export type PostDocumentObjectViewError = BadRequest
export function IsPostDocumentObjectViewError(e: any): e is PostDocumentObjectViewError {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest"
}
export const useDocumentObjectView = SSRHook<
    [body: PostDocumentObjectViewRequestBodyDto | null],
    PostDocumentObjectViewDto
>(
    "postDocumentObjectView",
    "PostDocumentObjectViewDto",
    undefined,
    postDocumentObjectView,
    ["body"],
    undefined
)
export type PostDocumentObjectDefaultsRequestBodyDto = { typeAlias: string; obj: any }
/** Populates an object of a specific type with defaults, according to the model.

 Returns the object with defaults populated. */
SSRHook.clientEndpoints.push({
    name: "postDocumentObjectDefaults",
    func: postDocumentObjectDefaults,
})
export async function postDocumentObjectDefaults(
    body: PostDocumentObjectDefaultsRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<any> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/document/object/defaults`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostDocumentObjectDefaultsError = BadRequest
export function IsPostDocumentObjectDefaultsError(e: any): e is PostDocumentObjectDefaultsError {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest"
}
export type PostDocumentPropertyDeclarationsRequestBodyDto = {
    declarationsFunc: string
    /** The document containing the property we want to compute declarations for.*/
    document: any
    /** The object within the document that we want to compute declarations for.

If not specified, the entire document will be used.*/
    object?: any
    /** Whether mutations operators should be included in the declarations.

This alone does not give the permissions to actually mutate the database,
but it does allow the user to see the mutation operators in the
intellisense declarations and use them in their scripts.

Whether the user can actually mutate the database is determined by the
context in which the script is executed.

Defaults to false.*/
    includeMutations?: boolean
}
export type PostDocumentPropertyDeclarationsDto = { code: string }
/** Computes declarations for script properties. */
SSRHook.clientEndpoints.push({
    name: "postDocumentPropertyDeclarations",
    func: postDocumentPropertyDeclarations,
})
export async function postDocumentPropertyDeclarations(
    body: PostDocumentPropertyDeclarationsRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostDocumentPropertyDeclarationsDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/document/property/declarations`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useDocumentPropertyDeclarations = SSRHook<
    [body: PostDocumentPropertyDeclarationsRequestBodyDto | null],
    PostDocumentPropertyDeclarationsDto
>(
    "postDocumentPropertyDeclarations",
    "PostDocumentPropertyDeclarationsDto",
    undefined,
    postDocumentPropertyDeclarations,
    ["body"],
    undefined
)
/** A string that holds TypeScript source code that can be executed in a certain environment.

 Use the `@declarations` attribute to point to a function that can emit declarations
 to populate intellisense with legal symbols. */
export type TypeScript = string
SSRHook.clientEndpoints.push({ name: "getDocumentsCount", func: getDocumentsCount })
export async function getDocumentsCount(
    collection: string,
    filter?: TypeScript,
    search?: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<number> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (collection !== undefined)
            queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()))
        if (filter !== undefined) queryArgs.push("filter=" + encodeURIComponent(filter.valueOf()))
        if (search !== undefined) queryArgs.push("search=" + encodeURIComponent(search.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/documents/count${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetDocumentsCountError = BadRequest
export function IsGetDocumentsCountError(e: any): e is GetDocumentsCountError {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest"
}
export const useDocumentsCount = SSRHook<
    [
        collection: string | null,
        filter: TypeScript | null | undefined,
        search: string | null | undefined,
    ],
    number
>(
    "getDocumentsCount",
    undefined,
    undefined,
    getDocumentsCount,
    ["collection", "filter", "search"],
    undefined
)
export type PostDocumentDto = {
    /** The version number given to the successfully posted document.

This is only returned if the collection supports versioning.*/
    newVersion: undefined | number
    /** The document after server side effects have been applied.*/
    newDocument: any
    /** The primary key of the newly inserted document.

If the primary key is auto-generated, this will be the value of the
primary key that was assigned by the database.*/
    primaryKey: string
}
/** Adds a new document to the given collection. */
SSRHook.clientEndpoints.push({ name: "postDocument", func: postDocument })
export async function postDocument(
    collection: string,
    body: any,
    allowErrors?: boolean,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostDocumentDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (collection !== undefined)
            queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()))
        if (allowErrors !== undefined)
            queryArgs.push("allowErrors=" + encodeURIComponent(allowErrors.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/document${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type Forbidden = {
    /** The type of this error, can be used for union discrimination*/ type: "Forbidden"
    status: number
    detail: string
    stack?: string
}
export type PostDocumentError = BadRequest | Forbidden
export function IsPostDocumentError(e: any): e is PostDocumentError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadRequest" || e.type === "Forbidden")
    )
}
SSRHook.clientEndpoints.push({ name: "deleteDocument", func: deleteDocument })
export async function deleteDocument(
    collection: string,
    primaryKey: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (collection !== undefined)
            queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()))
        if (primaryKey !== undefined)
            queryArgs.push("primaryKey=" + encodeURIComponent(primaryKey.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/document${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "delete",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type DeleteDocumentError = BadRequest | Forbidden
export function IsDeleteDocumentError(e: any): e is DeleteDocumentError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadRequest" || e.type === "Forbidden")
    )
}
export type PostDocumentConfirmChangesRequestBodyDto = {
    /** The entire new document (as a JSON string).*/ document: any
}
export type ButtonVariant = "primary" | "link" | "secondary" | "danger"
export type ConfirmChangesModal = {
    /** The contents of the modal dialog.*/ contents: Widget
    /** Text for the OK button. Defaults to "OK".*/
    ok?: string
    /** The style variant of the OK button. Defaults to "primary".*/
    okVariant?: ButtonVariant
    /** Text for the Cancel button. Defaults to "Cancel".*/
    cancel?: string
    /** The style variant of the Cancel button.*/
    cancelVariant?: ButtonVariant
}
export type PostDocumentConfirmChangesDto = { modals: ConfirmChangesModal[] }
/** Returns confirm change modals that the user must confirm prior to saving
 (PUT'ing) the document. */
SSRHook.clientEndpoints.push({
    name: "postDocumentConfirmChanges",
    func: postDocumentConfirmChanges,
})
export async function postDocumentConfirmChanges(
    collection: string,
    primaryKey: string,
    body: PostDocumentConfirmChangesRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostDocumentConfirmChangesDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (collection !== undefined)
            queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()))
        if (primaryKey !== undefined)
            queryArgs.push("primaryKey=" + encodeURIComponent(primaryKey.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/document/confirmChanges${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PutDocumentRequestBodyDto = {
    /** The entire new document (as a JSON string).*/ document: any
    /** Whether to accept inserting documents with validation errors. Defaults to
false.*/
    allowErrors?: boolean
    /** If set, this will only overwrite the document if the current version on the
server matches this version number. This can be used to prevent destructive overwrites.*/
    assertVersion?: number
    /** A human readable explanation this update.*/
    reason?: string
}
export type PutDocumentDto = {
    /** The version number given to the successfully posted new version of the document.

This is only returned if the collection supports versioning.*/
    newVersion: number
    /** The document after server side effects have been applied.*/
    newDocument: any
}
/** Replaces an entire document. */
SSRHook.clientEndpoints.push({ name: "putDocument", func: putDocument })
export async function putDocument(
    collection: string,
    primaryKey: string,
    body: PutDocumentRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PutDocumentDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/document/${collection}/${primaryKey}`,
            {
                method: "put",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type Conflict = {
    /** The type of this error, can be used for union discrimination*/ type: "Conflict"
    status: number
    detail: string
    stack?: string
}
export type PutDocumentError = Conflict | BadRequest | Forbidden
export function IsPutDocumentError(e: any): e is PutDocumentError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Conflict" || e.type === "BadRequest" || e.type === "Forbidden")
    )
}
/** Retrieves a particular version of a document. */
SSRHook.clientEndpoints.push({ name: "getDocument", func: getDocument })
export async function getDocument(
    collection: string,
    key: string,
    version?: number,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<any> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (collection !== undefined)
            queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()))
        if (key !== undefined) queryArgs.push("key=" + encodeURIComponent(key.valueOf()))
        if (version !== undefined)
            queryArgs.push("version=" + encodeURIComponent(version.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/document${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetDocumentError = BadRequest
export function IsGetDocumentError(e: any): e is GetDocumentError {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest"
}
export const useDocument = SSRHook<
    [collection: string | null, key: string | null, version: number | null | undefined],
    any
>("getDocument", undefined, undefined, getDocument, ["collection", "key", "version"], undefined)
export type DocumentDiagnostic = { key: string | number; message: string }
export type GetDocumentDiagnosticsDto = { collection: string; diagnostics: DocumentDiagnostic[] }
SSRHook.clientEndpoints.push({ name: "getDocumentDiagnostics", func: getDocumentDiagnostics })
export async function getDocumentDiagnostics(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetDocumentDiagnosticsDto[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/document/diagnostics`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type Unauthorized = {
    /** The type of this error, can be used for union discrimination*/ type: "Unauthorized"
    status: number
    detail: string
    stack?: string
}
export type GetDocumentDiagnosticsError = Unauthorized
export function IsGetDocumentDiagnosticsError(e: any): e is GetDocumentDiagnosticsError {
    return e && typeof e === "object" && "type" in e && e.type === "Unauthorized"
}
export const useDocumentDiagnostics = SSRHook<[], GetDocumentDiagnosticsDto[]>(
    "getDocumentDiagnostics",
    undefined,
    undefined,
    getDocumentDiagnostics,
    [],
    undefined
)
SSRHook.clientEndpoints.push({ name: "postDocumentRefresh", func: postDocumentRefresh })
export async function postDocumentRefresh(
    collection: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (collection !== undefined)
            queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/document/refresh${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "post",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type TooManyRequests = {
    /** The type of this error, can be used for union discrimination*/ type: "TooManyRequests"
    status: number
    detail: string
    stack?: string
}
export type PostDocumentRefreshError = BadRequest | TooManyRequests
export function IsPostDocumentRefreshError(e: any): e is PostDocumentRefreshError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadRequest" || e.type === "TooManyRequests")
    )
}
export type StudioTemplateDesc = {
    id: Uuid<"StudioTemplate">
    /** Name of the type this template is for.*/
    typeName: string
    /** Display name of the template, to make it easy to identify.*/
    name: Localized<string>
    /** More information about this template and its intened usage.*/
    description?: Localized<string>
    /** Name of the icon to display for this template, to make it easier to recognize.

If unspecified, the type's icon will be used.*/
    icon?: string
    /** Image to display for this template, to make it easier to recgonize.

If unspecified, an image from the content will be used.*/
    image?: Url
}
export type GetTemplatesDto = { templates: TemplateDesc[]; studioTemplates: StudioTemplateDesc[] }
/** Returns all available templates that are compatible with a given type name. */
SSRHook.clientEndpoints.push({ name: "getTemplates", func: getTemplates })
export async function getTemplates(
    typeName: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetTemplatesDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/templates/${typeName}/templates`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useTemplates = SSRHook<[typeName: string | null], GetTemplatesDto>(
    "getTemplates",
    "GetTemplatesDto",
    undefined,
    getTemplates,
    ["typeName"],
    undefined
)
/** Returns a new document from a studio template.

If the template belongs to a collection, it will be migrated according to the
rules of the collection.

A new primary key will be generated for the document. It is required that the
type has a UUID primary key.

The document will not be inserted into any collection (yet), but rather
returned for further processing on the client, typically for manual
inspection and editing. */
SSRHook.clientEndpoints.push({ name: "getStudioTemplate", func: getStudioTemplate })
export async function getStudioTemplate(
    id: Uuid<"StudioTemplate">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<any> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/templates/${id}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetStudioTemplateError = BadRequest
export function IsGetStudioTemplateError(e: any): e is GetStudioTemplateError {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest"
}
export const useStudioTemplate = SSRHook<[id: Uuid<"StudioTemplate"> | null], any>(
    "getStudioTemplate",
    undefined,
    undefined,
    getStudioTemplate,
    ["id"],
    undefined
)
export type PostDocumentsFromTemplateRequestBodyDto = {
    /** A dicionary of arguments to the template function. { [argName]: argValue }*/ args: any
    /** If specified, this will insert the generated documents into the
indicated collection, in addition to returning them.*/
    insertIntoCollection?: string
}
export type PostDocumentsFromTemplateDto = {
    /** The produced instances.*/ instances: any[]
}
/** Creates a batch of template instances a given type and template. */
SSRHook.clientEndpoints.push({ name: "postDocumentsFromTemplate", func: postDocumentsFromTemplate })
export async function postDocumentsFromTemplate(
    typeName: string,
    templateName: string,
    body: PostDocumentsFromTemplateRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostDocumentsFromTemplateDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/templates/${typeName}/${templateName}/create`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type NotFound = {
    /** The type of this error, can be used for union discrimination*/ type: "NotFound"
    status: number
    detail: string
    stack?: string
}
export type PostDocumentsFromTemplateError = NotFound | BadRequest
export function IsPostDocumentsFromTemplateError(e: any): e is PostDocumentsFromTemplateError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NotFound" || e.type === "BadRequest")
    )
}
SSRHook.clientEndpoints.push({
    name: "getNewDocumentFromExisting",
    func: getNewDocumentFromExisting,
})
export async function getNewDocumentFromExisting(
    collectionName: string,
    primaryKey: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<any> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/new-from-existing/${collectionName}/${primaryKey}/new`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetNewDocumentFromExistingError = NotFound
export function IsGetNewDocumentFromExistingError(e: any): e is GetNewDocumentFromExistingError {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound"
}
export const useNewDocumentFromExisting = SSRHook<
    [collectionName: string | null, primaryKey: string | null],
    any
>(
    "getNewDocumentFromExisting",
    undefined,
    undefined,
    getNewDocumentFromExisting,
    ["collectionName", "primaryKey"],
    undefined
)
export type GetStudioTableFiltersDto = {
    id: Uuid<"StudioTableFilter">
    /** A human-readable description of the filter.*/
    description: string
    /** The code that filters the collection.*/
    filterCode: TypeScript
}
export type ReturnType = GetStudioTableFiltersDto[]
SSRHook.clientEndpoints.push({ name: "getStudioTableFilters", func: getStudioTableFilters })
export async function getStudioTableFilters(
    collectionName: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<ReturnType> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (collectionName !== undefined)
            queryArgs.push("collectionName=" + encodeURIComponent(collectionName.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/table-filters${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetStudioTableFiltersError = NotFound
export function IsGetStudioTableFiltersError(e: any): e is GetStudioTableFiltersError {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound"
}
export const useStudioTableFilters = SSRHook<[collectionName: string | null], ReturnType>(
    "getStudioTableFilters",
    "ReturnType",
    undefined,
    getStudioTableFilters,
    ["collectionName"],
    undefined
)
export type PostStudioTableFilterRequestBodyDto = {
    collectionName: string
    description: Localized<string>
    filterCode: TypeScript
}
export type PostStudioTableFilterDto = { id: Uuid<"StudioTableFilter"> }
SSRHook.clientEndpoints.push({ name: "postStudioTableFilter", func: postStudioTableFilter })
export async function postStudioTableFilter(
    body: PostStudioTableFilterRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostStudioTableFilterDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/table-filters`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type JWTPropertyMissing = {
    /** The property name that was required in the JWT payload.*/ propName: string
    /** The expected type of the property*/
    expectedType?: string
    /** The type of this error, can be used for union discrimination*/
    type: "JWTPropertyMissing"
    status: number
    detail: string
    stack?: string
}
export type PostStudioTableFilterError = NotFound | Unauthorized | JWTPropertyMissing
export function IsPostStudioTableFilterError(e: any): e is PostStudioTableFilterError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NotFound" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing")
    )
}
export type PutStudioTableFilterRequestBodyDto = {
    filterCode: TypeScript
    description: Localized<string>
    private: boolean
}
SSRHook.clientEndpoints.push({ name: "putStudioTableFilter", func: putStudioTableFilter })
export async function putStudioTableFilter(
    id: Uuid<"StudioTableFilter">,
    body: PutStudioTableFilterRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/table-filters/${id}`,
            {
                method: "put",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
SSRHook.clientEndpoints.push({ name: "deleteStudioTableFilter", func: deleteStudioTableFilter })
export async function deleteStudioTableFilter(
    id: Uuid<"StudioTableFilter">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/table-filters/${id}`,
            {
                method: "delete",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetStudioTableFilterDeclarationsEndpointDto = { code: string }
SSRHook.clientEndpoints.push({
    name: "getStudioTableFilterDeclarationsEndpoint",
    func: getStudioTableFilterDeclarationsEndpoint,
})
export async function getStudioTableFilterDeclarationsEndpoint(
    collectionName: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetStudioTableFilterDeclarationsEndpointDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (collectionName !== undefined)
            queryArgs.push("collectionName=" + encodeURIComponent(collectionName.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/table-filter-declarations${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetStudioTableFilterDeclarationsEndpointError = NotFound | Forbidden
export function IsGetStudioTableFilterDeclarationsEndpointError(
    e: any
): e is GetStudioTableFilterDeclarationsEndpointError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NotFound" || e.type === "Forbidden")
    )
}
export const useStudioTableFilterDeclarationsEndpoint = SSRHook<
    [collectionName: string | null],
    GetStudioTableFilterDeclarationsEndpointDto
>(
    "getStudioTableFilterDeclarationsEndpoint",
    "GetStudioTableFilterDeclarationsEndpointDto",
    undefined,
    getStudioTableFilterDeclarationsEndpoint,
    ["collectionName"],
    undefined
)
export type GetStudioTableColumnsDto = {
    id: Uuid<"StudioTableColumn">
    /** The name of the column.*/
    name: string
    /** The display name of the column, localized.*/
    displayName: string
    /** A TypeScript expression that computes the value of the column.

This is the value that will be used for sorting and filtering based on
this column.

This expression must be SQL convertible and evaluate to a plain value.*/
    valueExpression: TypeScript
    /** Optional. A TypeScript expression that computes the widget representation
of the column based on the output of the valueExpression.

This only controls the visual appearance of the column in the studio, not
the sorting or filteringm value for the column.*/
    widgetExpression: undefined | TypeScript
    /** If true, a dropdown will be displayed in the table allowing you to filter
the column by selecting one or more values from this column. Rows that
match any of the selected values will be displayed.*/
    selectFilter: undefined | boolean
}
SSRHook.clientEndpoints.push({ name: "getStudioTableColumns", func: getStudioTableColumns })
export async function getStudioTableColumns(
    collectionName: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetStudioTableColumnsDto[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (collectionName !== undefined)
            queryArgs.push("collectionName=" + encodeURIComponent(collectionName.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/table-columns${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetStudioTableColumnsError = NotFound
export function IsGetStudioTableColumnsError(e: any): e is GetStudioTableColumnsError {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound"
}
export const useStudioTableColumns = SSRHook<
    [collectionName: string | null],
    GetStudioTableColumnsDto[]
>(
    "getStudioTableColumns",
    undefined,
    undefined,
    getStudioTableColumns,
    ["collectionName"],
    undefined
)
export type GetStudioTableColumnFilterOptionsRowsDto = { value: any; widget: any }
export type GetStudioTableColumnFilterOptionsDto = {
    rows: GetStudioTableColumnFilterOptionsRowsDto[]
    offset: number
    limit: number
}
SSRHook.clientEndpoints.push({
    name: "getStudioTableColumnFilterOptions",
    func: getStudioTableColumnFilterOptions,
})
export async function getStudioTableColumnFilterOptions(
    collectionName: string,
    columnName: string,
    search: string,
    offset?: number,
    limit?: number,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetStudioTableColumnFilterOptionsDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (search !== undefined) queryArgs.push("search=" + encodeURIComponent(search.valueOf()))
        if (offset !== undefined) queryArgs.push("offset=" + encodeURIComponent(offset.valueOf()))
        if (limit !== undefined) queryArgs.push("limit=" + encodeURIComponent(limit.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/table-columns/${collectionName}/filter-options/${columnName}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetStudioTableColumnFilterOptionsError = NotFound | BadRequest
export function IsGetStudioTableColumnFilterOptionsError(
    e: any
): e is GetStudioTableColumnFilterOptionsError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NotFound" || e.type === "BadRequest")
    )
}
export const useStudioTableColumnFilterOptions = SSRHook<
    [
        collectionName: string | null,
        columnName: string | null,
        search: string | null,
        offset: number | null | undefined,
        limit: number | null | undefined,
    ],
    GetStudioTableColumnFilterOptionsDto
>(
    "getStudioTableColumnFilterOptions",
    "GetStudioTableColumnFilterOptionsDto",
    undefined,
    getStudioTableColumnFilterOptions,
    ["collectionName", "columnName", "search", "offset", "limit"],
    undefined
)
export type AsyncWidgetSecret = string
export type GetAsyncWidgetDto = { content: Widget }
/** Returns the result of an async widget evaluation. */
SSRHook.clientEndpoints.push({ name: "getAsyncWidget", func: getAsyncWidget })
export async function getAsyncWidget(
    secret: AsyncWidgetSecret,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetAsyncWidgetDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/async-widget/${secret}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type RequestTimeout = {
    /** The type of this error, can be used for union discrimination*/ type: "RequestTimeout"
    status: number
    detail: string
    stack?: string
}
export type GetAsyncWidgetError = NotFound | RequestTimeout
export function IsGetAsyncWidgetError(e: any): e is GetAsyncWidgetError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NotFound" || e.type === "RequestTimeout")
    )
}
export const useAsyncWidget = SSRHook<[secret: AsyncWidgetSecret | null], GetAsyncWidgetDto>(
    "getAsyncWidget",
    "GetAsyncWidgetDto",
    undefined,
    getAsyncWidget,
    ["secret"],
    undefined
)
/** Renders a named widget.

 The named widget must be registered with Widget() and marked with an
 `authorize` function.

 The calling user must be authorized to render the widget by the `authroize`
 function. */
SSRHook.clientEndpoints.push({ name: "postWidget", func: postWidget })
export async function postWidget(
    name: string,
    param: string,
    body: WidgetRequest,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<WidgetResponse> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/widgets/${name}/${param}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostWidgetError = NotFound | Forbidden
export function IsPostWidgetError(e: any): e is PostWidgetError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NotFound" || e.type === "Forbidden")
    )
}
/** Performs an action on a named widget tree

 The named widget must be registered with Widget() and marked with an
 `authorize` attribute.

 The calling user must be authorized to render the widget by the `authroize`
 function.

 The widget my specify an additional `actionAuthorization` function, which is
 called to authorize the particular action. If the widget does not specify an
 `actionAuthorization` function, the `StudioAuthorization` is used by
 default, meaning the action is limited to what the user is allowed to do in
 Studio. */
SSRHook.clientEndpoints.push({ name: "postWidgetAction", func: postWidgetAction })
export async function postWidgetAction(
    name: string,
    param: string,
    widgetKey: string,
    body: WidgetActionRequest,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<WidgetActionResponse> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/widgets/${name}/${param}/${widgetKey}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostWidgetActionError = NotFound | Forbidden | Unauthorized | JWTPropertyMissing
export function IsPostWidgetActionError(e: any): e is PostWidgetActionError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NotFound" ||
            e.type === "Forbidden" ||
            e.type === "Unauthorized" ||
            e.type === "JWTPropertyMissing")
    )
}
/** Represents a permission rule that can be granted to some executing code. */
export type CollectionPermission = {
    type: "Collection Permission"
    /** Name of the collection for which permissions are given.*/
    collection: string
    canFilter?: boolean
    canRead?: boolean
    canUpdate?: boolean
    canInsert?: boolean
    canDelete?: boolean
    /** Whether the user has permission to insert or update documents in this
collection in violation of the type schema.

This is useful for super users needing to manually repair data after
failed migrations or similar, but should not be used in normal operation.*/
    canBypassValidation?: boolean
}
export type DocumentRole = "Owner" | "Editor" | "Viewer"
export type DocumentPermission = {
    type: "Document Permission"
    /** Name of the collection for which permissions are given.*/
    collection: string
    /** ID of the document for which permissions are given.*/
    document: string
    /** What role the user has for this document.

Owners can do anything with the document, including sharing it with
others, or deleting it. By sharing, we mean handing out document
permission through the share API.

Editors can read and update the document.

Viewers can only read the document.*/
    role: DocumentRole
}
export type FolderPermission = {
    type: "Folder Permission"
    /** The folder for which permissions are given.*/
    folder: Uuid<"Folder">
    /** Whether the user can read the contents of the folder.*/
    canRead?: boolean
    /** Whether the user can upload files to the folder.*/
    canUpload?: boolean
    /** Whether the user can manage the contents of the folder, such as
inserting, deleting and organizing files and subfolders.

Note that `canUpload` is a sufficient to upload files.*/
    canManageContents?: boolean
    /** Whether the user can manage the settings of the folder.*/
    canManageSettings?: boolean
}
export type EndpointPermission = {
    type: "Endpoint Permission"
    /** Name of the restricted endpoint the user is permitted to call.*/
    endpoint: string
    /** Textual description of what this permission means.*/
    description?: string
}
export type CustomPermission = {
    type: "Custom Permission"
    /** Name of the permission.

Often reads like "Can do some stuff".

The model code can recognize this string and allow custom behavior.*/
    name: string
    /** Model and permission specific parameter string.*/
    parameter?: string
}
export type Permission =
    | CollectionPermission
    | DocumentPermission
    | FolderPermission
    | EndpointPermission
    | CustomPermission
export type MenuItemVisibility = {
    /** List of menu items to show.
This is the URL slug of the menu item.*/
    show: string[]
    /** List of menu items to hide. A hidden menu item takes precedens over shown menu items.
This means that if you have a menu item both shown and hidden, it will not be shown.
This is the URL slug of the menu item.*/
    hide: string[]
}
export type Avatar = {
    color?:
        | "warning"
        | "error"
        | "gray"
        | "primary"
        | "success"
        | "gray-blue"
        | "gray-cool"
        | "gray-modern"
        | "gray-neutral"
        | "gray-iron"
        | "gray-true"
        | "gray-warm"
        | "moss"
        | "green-light"
        | "green"
        | "teal"
        | "cyan"
        | "blue-light"
        | "blue"
        | "blue-dark"
        | "indigo"
        | "violet"
        | "purple"
        | "fuchsia"
        | "pink"
        | "rosé"
        | "orange-dark"
        | "orange"
        | "yellow"
    initials?: string
    image?: Url
}
export type StudioUser = {
    /** The verified email address from a trusted claims issuer.
This is the primary key for the user and can not be changed.*/
    email: Email
    /** Optional. The given name of the user.*/
    givenName?: string
    /** Optional. The family name of the user.*/
    familyName?: string
    /** Roles given to this user, which can come with permissions.*/
    roles?: Uuid<"StudioRole">[]
    /** Explicit permissions given to this user.*/
    permissions?: Permission[]
    /** Controls what this user sees in the Studio menu.

This overrides any preferences on the user's roles. However, it is
limited to the permissions of the user.*/
    menuItemVisibility?: MenuItemVisibility
    /** Allows the user to configure their avatar appearance in Reactor Studio.

If unspecified, the avatar is auto-generated based on the other user information.*/
    avatar?: Avatar
    /** The ID of the user in the analytics system.

This allows the user to be associated with analytics events even after
they are deleted.*/
    analyticsId?: Uuid<"Uuid">
}
export type GetReactorMe1Dto = {
    canUseGlobalSearch?: boolean
    canPostPrimaryDataset?: boolean
    canGetPrimaryDataset?: boolean
}
export type GetReactorMeDto = StudioUser & GetReactorMe1Dto
SSRHook.clientEndpoints.push({ name: "getReactorMe", func: getReactorMe })
export async function getReactorMe(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetReactorMeDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/reactor/me`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetReactorMeError = Unauthorized | JWTPropertyMissing
export function IsGetReactorMeError(e: any): e is GetReactorMeError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Unauthorized" || e.type === "JWTPropertyMissing")
    )
}
export const useReactorMe = SSRHook<[], GetReactorMeDto>(
    "getReactorMe",
    "GetReactorMeDto",
    undefined,
    getReactorMe,
    [],
    undefined
)
export type GetWebSocketTicketForStudioUserDto = { ticket: Uuid<"Uuid"> }
SSRHook.clientEndpoints.push({
    name: "getWebSocketTicketForStudioUser",
    func: getWebSocketTicketForStudioUser,
})
export async function getWebSocketTicketForStudioUser(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetWebSocketTicketForStudioUserDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/reactor/ticket`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetWebSocketTicketForStudioUserError = Unauthorized | JWTPropertyMissing
export function IsGetWebSocketTicketForStudioUserError(
    e: any
): e is GetWebSocketTicketForStudioUserError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Unauthorized" || e.type === "JWTPropertyMissing")
    )
}
export const useWebSocketTicketForStudioUser = SSRHook<[], GetWebSocketTicketForStudioUserDto>(
    "getWebSocketTicketForStudioUser",
    "GetWebSocketTicketForStudioUserDto",
    undefined,
    getWebSocketTicketForStudioUser,
    [],
    undefined
)
/** Represents a set of cookie consents. */
export type CookieConsents = {
    /** Whether the user has consented to necessary cookies.

Necessary cookies are required for the website or service to function
properly. They are usually set in response to actions made by you which
amount to a request for services, such as setting your privacy
preferences, logging in or filling in forms.*/
    necessary: boolean
    /** Whether the user has consented to preferences cookies.

Preferences cookies enable a website to remember information that
changes the way the website behaves or looks, like your preferred
language or the region that you are in.*/
    preferences: boolean
    /** Whether the user has consented to statistics cookies.

Statistics cookies help website owners to understand how visitors
interact with websites by collecting and reporting information
anonymously.*/
    statistics: boolean
    /** Whether the user has consented to marketing cookies.

Marketing cookies are used to track visitors across websites. The
intention is to display ads that are relevant and engaging for the
individual user and thereby more valuable for publishers and third party
advertisers.*/
    marketing: boolean
}
/** Updates the cookie consents for the caller. */
SSRHook.clientEndpoints.push({ name: "putCookieConsents", func: putCookieConsents })
export async function putCookieConsents(
    body: CookieConsents,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/cookie-consents`,
            {
                method: "put",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PutCookieConsentsError = Conflict
export function IsPutCookieConsentsError(e: any): e is PutCookieConsentsError {
    return e && typeof e === "object" && "type" in e && e.type === "Conflict"
}
export type GetCookieConsentsConsentsCookieConsentsRecord0Dto = {
    id: Uuid<"CookieConsentsRecord">
    /** The timestamp of when the consents were originally created.

Note that the consents can have been changed since this timestamp.*/
    created: Timestamp
    /** The timestamp of the latest renewal of the consents, to the current
state.*/
    latestRenewal: Timestamp
    /** If the consent was not given directly to our system, this field
specifies the source of the consent.*/
    source?: "cookiebot"
}
export type CookieConsentsRecord = GetCookieConsentsConsentsCookieConsentsRecord0Dto &
    CookieConsents
export type CookieConsentInfo = {
    /** A logo displayed in the cookie consent banner.*/ logo?: Url
    colorMode: "light" | "dark"
    title: Localized<string>
    description: Localized<Markdown>
    /** The display name for the "necessary" cookie consent type.*/
    necessary: Localized<string>
    /** A description of the "necessary" cookies to help the user understand what they are forced to accept.*/
    necessaryDescription: Localized<string>
    /** The display name for the "preferences" cookie consent type.*/
    preferences: Localized<string>
    /** A description of the "preferences" cookies to help the user understand what they are accepting or not.*/
    preferencesDescription: Localized<string>
    /** The display name for the "statistics" cookie consent type.*/
    statistics: Localized<string>
    /** A description of the "statistics" cookies to help the user understand what they are accepting or not.*/
    statisticsDescription: Localized<string>
    /** The display name for the "marketing" cookie consent type.*/
    marketing: Localized<string>
    /** A description of the "marketing" cookies to help the user understand what they are accepting or not.*/
    marketingDescription: Localized<string>
    /** The display title for the "allow all" button.*/
    allowAll: Localized<string>
    /** The display title for the "allow selection" button.*/
    allowSelection: Localized<string>
    /** The display title for the "deny" button.*/
    deny: Localized<string>
    /** The display title for the "customize" button.*/
    customize: Localized<string>
    /** A page to link to describing the site’s privacy policy.
Requires the page to have a slug and a title.*/
    privacyPolicyPage?: Uuid<"WebPage">
}
export type GetCookieConsentsDto = {
    consents: undefined | CookieConsentsRecord
    info: undefined | CookieConsentInfo
}
SSRHook.clientEndpoints.push({ name: "getCookieConsents", func: getCookieConsents })
export async function getCookieConsents(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetCookieConsentsDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/cookie-consents`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useCookieConsents = SSRHook<[], GetCookieConsentsDto>(
    "getCookieConsents",
    "GetCookieConsentsDto",
    "CookieConsents",
    getCookieConsents,
    [],
    (args, body) => putCookieConsents.apply(null, [body] as any)
)
SSRHook.clientEndpoints.push({ name: "getPaymentStatus", func: getPaymentStatus })
export async function getPaymentStatus(
    adyenOrder: string,
    adyenOrderId: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetPaymentStatusDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/payments/status/${adyenOrder}/${adyenOrderId}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const usePaymentStatus = SSRHook<
    [adyenOrder: string | null, adyenOrderId: string | null],
    GetPaymentStatusDto
>(
    "getPaymentStatus",
    "GetPaymentStatusDto",
    undefined,
    getPaymentStatus,
    ["adyenOrder", "adyenOrderId"],
    undefined
)
export type GetMerchantConfigDto = {
    adyenEnvironment: "test" | "live-eu" | "live-us" | "live-au" | "live-apse" | "live-in"
    adyenClientKey: string
    adyenOrder: string
    adyenOrderId: string
}
SSRHook.clientEndpoints.push({ name: "getMerchantConfig", func: getMerchantConfig })
export async function getMerchantConfig(
    adyenOrder: string,
    adyenOrderId: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetMerchantConfigDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (adyenOrder !== undefined)
            queryArgs.push("adyenOrder=" + encodeURIComponent(adyenOrder.valueOf()))
        if (adyenOrderId !== undefined)
            queryArgs.push("adyenOrderId=" + encodeURIComponent(adyenOrderId.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/payments/merchant-config${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useMerchantConfig = SSRHook<
    [adyenOrder: string | null, adyenOrderId: string | null],
    GetMerchantConfigDto
>(
    "getMerchantConfig",
    "GetMerchantConfigDto",
    undefined,
    getMerchantConfig,
    ["adyenOrder", "adyenOrderId"],
    undefined
)
export type GetPaymentMethodsDto = {
    /** Upstream Result from Adyen*/ result: any
    amount: PaymentAmount
    adyenLocale: undefined | string
    adyenOrder: string
    adyenOrderId: string
    locale: LocaleKey
    channel: PaymentChannel
}
SSRHook.clientEndpoints.push({ name: "getPaymentMethods", func: getPaymentMethods })
export async function getPaymentMethods(
    adyenOrder: string,
    adyenOrderId: string,
    locale: LocaleKey,
    channel: PaymentChannel,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetPaymentMethodsDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (locale !== undefined) queryArgs.push("locale=" + encodeURIComponent(locale.valueOf()))
        if (channel !== undefined)
            queryArgs.push("channel=" + encodeURIComponent(channel.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/payments/methods/${adyenOrder}/${adyenOrderId}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type InternalServerError = {
    /** The type of this error, can be used for union discrimination*/ type: "InternalServerError"
    status: number
    detail: string
    stack?: string
}
export type GetPaymentMethodsError = InternalServerError
export function IsGetPaymentMethodsError(e: any): e is GetPaymentMethodsError {
    return e && typeof e === "object" && "type" in e && e.type === "InternalServerError"
}
export const usePaymentMethods = SSRHook<
    [
        adyenOrder: string | null,
        adyenOrderId: string | null,
        locale: LocaleKey | null,
        channel: PaymentChannel | null,
    ],
    GetPaymentMethodsDto
>(
    "getPaymentMethods",
    "GetPaymentMethodsDto",
    undefined,
    getPaymentMethods,
    ["adyenOrder", "adyenOrderId", "locale", "channel"],
    undefined
)
export type PostPaymentRequest = {
    locale: LocaleKey
    adyenData: any
    channel: PaymentChannel
    /** Test parameter for forcing 3D Secure authentication with default mode redirect.
Only available in test environments.
Source: https://docs.adyen.com/api-explorer/Checkout/70/post/payments#request-authenticationData-attemptAuthentication*/
    auth3ds?: boolean
    /** Test parameter for triggering certain Adyen responses.
Only available in test environments.
Source: https://docs.adyen.com/development-resources/refusal-reasons*/
    testCode?: number
}
export type EmptyVariant = "Error"
export type ResultCode =
    | EmptyVariant
    | "Refused"
    | "Cancelled"
    | "AuthenticationFinished"
    | "AuthenticationNotRequired"
    | "Authorised"
    | "ChallengeShopper"
    | "IdentifyShopper"
    | "Pending"
    | "PresentToShopper"
    | "Received"
    | "RedirectShopper"
    | "PartiallyAuthorised"
    | "Success"
export type PostPaymentResult = {
    resultCode?: ResultCode
    action?: any
    refusalReason?: string
    refusalReasonCode?: string
    [key: string]: any
}
export type PostPayment0Dto = {
    /** Upstream Result from Adyen*/ result: PostPaymentResult
}
/** Object that contains some of the request parameters.
Should be avoided in favor of keeping the parameters from the request on hand. */
export type RequestEcho = { adyenOrder: string; adyenOrderId: string; body: any }
export type PostPaymentResponse = PostPayment0Dto & RequestEcho
SSRHook.clientEndpoints.push({ name: "postPayment", func: postPayment })
export async function postPayment(
    adyenOrder: string,
    adyenOrderId: string,
    body: PostPaymentRequest,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostPaymentResponse> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/payments/payment/${adyenOrder}/${adyenOrderId}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostPaymentError = InternalServerError
export function IsPostPaymentError(e: any): e is PostPaymentError {
    return e && typeof e === "object" && "type" in e && e.type === "InternalServerError"
}
export type PostAdditionalDetailsRequestBodyDto = { details: any; paymentData?: null | string }
export type PostAdditionalDetailsResult = { resultCode?: ResultCode; [key: string]: any }
export type PostAdditionalDetails0Dto = {
    /** Upstream Result from Adyen*/ result: PostAdditionalDetailsResult
}
export type PostAdditionalDetailsResponse = PostAdditionalDetails0Dto & RequestEcho
SSRHook.clientEndpoints.push({ name: "postAdditionalDetails", func: postAdditionalDetails })
export async function postAdditionalDetails(
    adyenOrder: string,
    adyenOrderId: string,
    body: PostAdditionalDetailsRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostAdditionalDetailsResponse> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (adyenOrder !== undefined)
            queryArgs.push("adyenOrder=" + encodeURIComponent(adyenOrder.valueOf()))
        if (adyenOrderId !== undefined)
            queryArgs.push("adyenOrderId=" + encodeURIComponent(adyenOrderId.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/payments/additional-details${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostAdditionalDetailsError = InternalServerError
export function IsPostAdditionalDetailsError(e: any): e is PostAdditionalDetailsError {
    return e && typeof e === "object" && "type" in e && e.type === "InternalServerError"
}
SSRHook.clientEndpoints.push({ name: "getShopperRedirect", func: getShopperRedirect })
export async function getShopperRedirect(
    paymentId: string,
    locale: LocaleKey,
    redirectUrl?: string,
    redirectResult?: string,
    mD?: string,
    paRes?: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (paymentId !== undefined)
            queryArgs.push("paymentId=" + encodeURIComponent(paymentId.valueOf()))
        if (locale !== undefined) queryArgs.push("locale=" + encodeURIComponent(locale.valueOf()))
        if (redirectUrl !== undefined)
            queryArgs.push("redirectUrl=" + encodeURIComponent(redirectUrl.valueOf()))
        if (redirectResult !== undefined)
            queryArgs.push("redirectResult=" + encodeURIComponent(redirectResult.valueOf()))
        if (mD !== undefined) queryArgs.push("mD=" + encodeURIComponent(mD.valueOf()))
        if (paRes !== undefined) queryArgs.push("paRes=" + encodeURIComponent(paRes.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/payments/shopper-redirect${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetShopperRedirectError = InternalServerError
export function IsGetShopperRedirectError(e: any): e is GetShopperRedirectError {
    return e && typeof e === "object" && "type" in e && e.type === "InternalServerError"
}
export const useShopperRedirect = SSRHook<
    [
        paymentId: string | null,
        locale: LocaleKey | null,
        redirectUrl: string | null | undefined,
        redirectResult: string | null | undefined,
        mD: string | null | undefined,
        paRes: string | null | undefined,
    ],
    void
>(
    "getShopperRedirect",
    undefined,
    undefined,
    getShopperRedirect,
    ["paymentId", "locale", "redirectUrl", "redirectResult", "mD", "paRes"],
    undefined
)
export type PostShopperRedirectRequestBodyDto = {
    redirectUrl?: string
    redirectResult?: string
    mD?: string
    paRes?: string
}
SSRHook.clientEndpoints.push({ name: "postShopperRedirect", func: postShopperRedirect })
export async function postShopperRedirect(
    paymentId: string,
    locale: LocaleKey,
    body: PostShopperRedirectRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (paymentId !== undefined)
            queryArgs.push("paymentId=" + encodeURIComponent(paymentId.valueOf()))
        if (locale !== undefined) queryArgs.push("locale=" + encodeURIComponent(locale.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/payments/shopper-redirect/${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostShopperRedirectError = InternalServerError
export function IsPostShopperRedirectError(e: any): e is PostShopperRedirectError {
    return e && typeof e === "object" && "type" in e && e.type === "InternalServerError"
}
SSRHook.clientEndpoints.push({ name: "postAdyenWebhook", func: postAdyenWebhook })
export async function postAdyenWebhook(
    body: any,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<string> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/payments/adyen-webhook`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.text()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostAdyenWebhookError = Unauthorized
export function IsPostAdyenWebhookError(e: any): e is PostAdyenWebhookError {
    return e && typeof e === "object" && "type" in e && e.type === "Unauthorized"
}
/** Internal Receipt endpoint, do not attempt to use this endpoint directly. */
SSRHook.clientEndpoints.push({ name: "getReceiptHtml", func: getReceiptHtml })
export async function getReceiptHtml(
    secret: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<string> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (secret !== undefined) queryArgs.push("secret=" + encodeURIComponent(secret.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/payments/receipts/html${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.text()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetReceiptHtmlError = NotFound
export function IsGetReceiptHtmlError(e: any): e is GetReceiptHtmlError {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound"
}
export const useReceiptHtml = SSRHook<[secret: string | null], string>(
    "getReceiptHtml",
    undefined,
    undefined,
    getReceiptHtml,
    ["secret"],
    undefined
)
export type MessageSID = string
export type PostSmsStatusRequestBodyDto = {
    accountId: Uuid<"ResourceAccount">
    messageSID: MessageSID
    status: string
    detailedStatus: string
    received: Timestamp
}
SSRHook.clientEndpoints.push({ name: "postSmsStatus", func: postSmsStatus })
export async function postSmsStatus(
    body: PostSmsStatusRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/fuse-webhooks/sms-status`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostSmsStatusError = Unauthorized
export function IsPostSmsStatusError(e: any): e is PostSmsStatusError {
    return e && typeof e === "object" && "type" in e && e.type === "Unauthorized"
}
SSRHook.clientEndpoints.push({ name: "unsubscribeEndpoint", func: unsubscribeEndpoint })
export async function unsubscribeEndpoint(
    secret: Uuid<"UnsubscribeSecret">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<string> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/email-unsubscribe/${secret}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.text()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostEmailStatusRequestBodyDto = {
    meta: { accountId: string; id: number; serviceRef: string }
    event: { status: string; timestamp: number }
}
/** A webhook for getting status updates on email delivery from Fuseops. */
SSRHook.clientEndpoints.push({ name: "postEmailStatus", func: postEmailStatus })
export async function postEmailStatus(
    body: PostEmailStatusRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/fuse-webhooks/email-status`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostEmailStatusError = Forbidden | NotFound | BadRequest
export function IsPostEmailStatusError(e: any): e is PostEmailStatusError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Forbidden" || e.type === "NotFound" || e.type === "BadRequest")
    )
}
export type PostEmailPreviewResultRequestBodyDto = {
    sentMailId: Uuid<"SentMail">
    previews: { clientId: string; thumbnailUrl: Url; screenshotUrl: Url }[]
}
SSRHook.clientEndpoints.push({ name: "postEmailPreviewResult", func: postEmailPreviewResult })
export async function postEmailPreviewResult(
    body: PostEmailPreviewResultRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/fuse-webhooks/email-preview`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostEmailPreviewResultError = NotFound | BadRequest
export function IsPostEmailPreviewResultError(e: any): e is PostEmailPreviewResultError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NotFound" || e.type === "BadRequest")
    )
}
/** Represents the server-side state of an operation in progress. */
export type GetProgressOperationsFailedItemsDto = { activity: string; error: string }
/** How to handle user-initiated cancellation of the operation.

- `"throw"` (default), the operation will throw an error when the user
  cancels it.

- `"disallow" `: the operation cannot be cancelled by the user.

- `"allow-and-continue"`, the operation will continue to run after the user
  cancels it, even if it has not yet finished all items. */
export type ProgressOperationCancelPolicy = "disallow" | "allow-and-continue" | "throw"
export type ProgressOperation = {
    id: Uuid<"OngoingOperation">
    /** The studio user owning this operation*/
    studioUser: Email
    description: string
    currentActivity?: string
    progress?: number
    progressMax?: number
    failedItems: GetProgressOperationsFailedItemsDto[]
    /** Whether the operation has completed. If true, this is likely because it
has failed items for the user to inspect. Otherwise, completed operations
are deleted automatically.*/
    isComplete: boolean
    /** How to handle user-initiated cancellation of the operation.

Defaults to "throw".*/
    cancelPolicy: ProgressOperationCancelPolicy
}
SSRHook.clientEndpoints.push({ name: "getProgressOperations", func: getProgressOperations })
export async function getProgressOperations(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<ProgressOperation[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/progress-operations`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetProgressOperationsError = Unauthorized | JWTPropertyMissing
export function IsGetProgressOperationsError(e: any): e is GetProgressOperationsError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Unauthorized" || e.type === "JWTPropertyMissing")
    )
}
export const useProgressOperations = SSRHook<[], ProgressOperation[]>(
    "getProgressOperations",
    undefined,
    undefined,
    getProgressOperations,
    [],
    undefined
)
/** Cancels an ongoing progress operation. */
SSRHook.clientEndpoints.push({ name: "deleteProgressOperation", func: deleteProgressOperation })
export async function deleteProgressOperation(
    id: Uuid<"OngoingOperation">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/progress-operations/${id}`,
            {
                method: "delete",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type DeleteProgressOperationError = Forbidden | Unauthorized | JWTPropertyMissing
export function IsDeleteProgressOperationError(e: any): e is DeleteProgressOperationError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Forbidden" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing")
    )
}
export type FileShareSetting = "AnyoneWithLink" | "AnyoneWithFolderAccess"
/** Represents a base64 encoded ThumbHash of an image. */
export type ThumbHash = string
export type FileRecord = {
    /** The unique id of the file.
This is a secret. If `share` is set to `"AnyoneWithLink"`, anyone with the ID/URL can retrieve the file.*/
    id: Uuid<"Uuid">
    /** The display name of the file when downloaded.*/
    name: string
    /** The folder this file is in.*/
    folder: Uuid<"Folder">
    /** The Studio User who owns this file*/
    owner?: Email
    /** Configures who has read access to this file through `/api/files`.

Leaving this undefined will make the file private to the owner, unless
access is explicitly granted through and access policy.*/
    share?: FileShareSetting
    /** The size of the file, in bytes.*/
    size: number
    /** The type of file.*/
    mimetype: string
    /** A temporary file will automatically be deleted by an interval job.*/
    temporary?: boolean
    /** The date the file was uploaded.*/
    uploadedAt?: Timestamp
    /** If this file is uploaded from a source URL, this is the source URL. This
can be used to check for files we have already downloaded.*/
    sourceUrl?: Url
    /** If this file is uploaded from a source URL, this is the ETag of the file
at the source URL. This can be used to check for changes in the file.*/
    sourceEtag?: string
    /** A base64 encoded thumbnail of the file, if available. The thumbhash
result will be cached here when available, so it doesn't have to be
computed every time the file is accessed.

This field can also hold two special values:
- "generate": Indicates that the thumbhash should be generated in the
background, but no background job has picked it up yet.
- "generating": Indicates that the thumbhash is currently being
generated by a background job.*/
    thumbHash?: ThumbHash
    /** Whether this file is an image that has been used in an email.

If an image has been used in an email, it will be available for
anonoymous access throught he /email-images endpoint, which has
cross-origin CORP enabled. This is required for compatibility with
email clients that are strict about such things, like Outlook.*/
    emailImage?: boolean
}
export type PostFilesDto = { files: FileRecord[] }
SSRHook.clientEndpoints.push({ name: "postFiles", func: postFiles })
export async function postFiles(
    folder: string | Uuid<"Folder">,
    uploadedFiles: any[],
    share?: "AnyoneWithLink" | "AnyoneWithFolderAccess" | "FolderDefault",
    mimetype?: string,
    temporaryFile?: boolean,
    originalFileName?: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostFilesDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (share !== undefined) queryArgs.push("share=" + encodeURIComponent(share.valueOf()))
        if (mimetype !== undefined)
            queryArgs.push("mimetype=" + encodeURIComponent(mimetype.valueOf()))
        if (temporaryFile !== undefined)
            queryArgs.push("temporaryFile=" + encodeURIComponent(temporaryFile.valueOf()))
        if (originalFileName !== undefined)
            queryArgs.push("originalFileName=" + encodeURIComponent(originalFileName.valueOf()))

        const formData = new FormData()

        for (const file of uploadedFiles) {
            formData.append("file", file)
        }

        const headers = { ...defaults.headers, ...customHeaders }
        delete headers["Content-Type"]
        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/folders/${folder}/files${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "post",
                headers,
                body: formData,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostFilesError = Forbidden | BadRequest | Unauthorized | JWTPropertyMissing
export function IsPostFilesError(e: any): e is PostFilesError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Forbidden" ||
            e.type === "BadRequest" ||
            e.type === "Unauthorized" ||
            e.type === "JWTPropertyMissing")
    )
}
export type Int = number
SSRHook.clientEndpoints.push({ name: "getFileInfo", func: getFileInfo })
export async function getFileInfo(
    id: File,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<FileRecord> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/files/${id}/info`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetFileInfoError = NotFound
export function IsGetFileInfoError(e: any): e is GetFileInfoError {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound"
}
export const useFileInfo = SSRHook<[id: File | null], FileRecord>(
    "getFileInfo",
    "FileRecord",
    undefined,
    getFileInfo,
    ["id"],
    undefined
)
export type PostStudioImportRequestBodyDto = {
    /** The CSV content to import.*/ csv: string
}
/** Imports a CSV file into a collection using a StudioImporter. */
SSRHook.clientEndpoints.push({ name: "postStudioImport", func: postStudioImport })
export async function postStudioImport(
    importerId: Uuid<"StudioImporter">,
    body: PostStudioImportRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/importers/${importerId}/import`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostStudioImportError = BadRequest | Unauthorized | JWTPropertyMissing
export function IsPostStudioImportError(e: any): e is PostStudioImportError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadRequest" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing")
    )
}
export type GetStudioConsoleDeclarationsDto = { declarations: string }
/** Returns the TSQ declarations available to the current user. */
SSRHook.clientEndpoints.push({
    name: "getStudioConsoleDeclarations",
    func: getStudioConsoleDeclarations,
})
export async function getStudioConsoleDeclarations(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetStudioConsoleDeclarationsDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/console/declarations`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useStudioConsoleDeclarations = SSRHook<[], GetStudioConsoleDeclarationsDto>(
    "getStudioConsoleDeclarations",
    "GetStudioConsoleDeclarationsDto",
    undefined,
    getStudioConsoleDeclarations,
    [],
    undefined
)
export type StudioConsoleQuery = { id: Uuid<"StudioConsoleQuery">; code: TypeScript }
/** Retrieves a stored query by ID. */
SSRHook.clientEndpoints.push({ name: "getStudioConsoleQuery", func: getStudioConsoleQuery })
export async function getStudioConsoleQuery(
    id: Uuid<"StudioConsoleQuery">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<StudioConsoleQuery> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (id !== undefined) queryArgs.push("id=" + encodeURIComponent(id.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/console/query${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useStudioConsoleQuery = SSRHook<
    [id: Uuid<"StudioConsoleQuery"> | null],
    StudioConsoleQuery
>(
    "getStudioConsoleQuery",
    "StudioConsoleQuery",
    undefined,
    getStudioConsoleQuery,
    ["id"],
    undefined
)
export type PostStudioConsoleQueryRequestBodyDto = { code: TypeScript; state: any }
export type PostStudioConsoleQueryDto = {
    id: Uuid<"StudioConsoleQuery">
    code: TypeScript
    widget: any
}
/** Evaluates a console query (TSQ expression).

If the code snippet has not been stored before, it is stored and given an ID.
If the code snippet has been stored before, the stored ID is returned. */
SSRHook.clientEndpoints.push({ name: "postStudioConsoleQuery", func: postStudioConsoleQuery })
export async function postStudioConsoleQuery(
    body: PostStudioConsoleQueryRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostStudioConsoleQueryDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/console`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostStudioConsoleQueryError = BadRequest | Forbidden | NotFound | Conflict
export function IsPostStudioConsoleQueryError(e: any): e is PostStudioConsoleQueryError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadRequest" ||
            e.type === "Forbidden" ||
            e.type === "NotFound" ||
            e.type === "Conflict")
    )
}
export type PostStudioConsoleQueryActionRequestBodyDto = {
    method?: string
    state: any
    args: any[]
}
export type PostStudioConsoleQueryActionDto = {
    id: Uuid<"StudioConsoleQuery">
    code: TypeScript
    widget: any
    effects: ClientEffect[]
    state: any
    result: any
}
/** Performs an action on the result of a console query (TSQ expression). */
SSRHook.clientEndpoints.push({
    name: "postStudioConsoleQueryAction",
    func: postStudioConsoleQueryAction,
})
export async function postStudioConsoleQueryAction(
    id: Uuid<"StudioConsoleQuery">,
    widgetKey: string,
    body: PostStudioConsoleQueryActionRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostStudioConsoleQueryActionDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/console/${id}/actions/${widgetKey}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostStudioConsoleQueryActionError =
    | BadRequest
    | Forbidden
    | NotFound
    | Conflict
    | Unauthorized
    | JWTPropertyMissing
export function IsPostStudioConsoleQueryActionError(
    e: any
): e is PostStudioConsoleQueryActionError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadRequest" ||
            e.type === "Forbidden" ||
            e.type === "NotFound" ||
            e.type === "Conflict" ||
            e.type === "Unauthorized" ||
            e.type === "JWTPropertyMissing")
    )
}
export type PostStudioPageRequestBodyDto = {
    /** A set of primary keys to exclude from the table, if the page is a table.

This only applies if `path` is a collection name.

This is useful e.g. to prevent common cases of accidental circular referencing.*/
    excludePrimaryKeys?: string[]
    /** The state variables used to configure the view (e.g. page index, search string etc.)

This is a two-level dictionary object where the top level identifies the widget, and the
second level holds the state(s) for that widget.*/
    state: any
    /** If the path is an options function, this must hold the entire document for which we are
requesting options.*/
    document?: any
    /** If the path is an options function, this must hold the object for which we are requesting options.*/
    object?: any
    /** If the path is an options function, this must hold the name of the property that is used to
reference the option.*/
    refKey?: string
    /** If this a user-defined page, this is a potentially client-side-modified
version of the page code. This is used to preview the page before saving
it.*/
    previewCode?: TypeScript
}
export type PostStudioPageUserDefinedPageDto = {
    id: Uuid<"UserDefinedStudioPage">
    code: TypeScript
    /** Whether we are currently returning a preview of the provided previewCode.*/
    preview?: boolean
}
export type PostStudioPageDto = {
    content: any
    /** The widget state after rendering this page. Although this is a read operation, the state may
be changed to correct for invalid values.*/
    state: any
    /** If defined, this response corresponds to a user-defined page.*/
    userDefinedPage?: PostStudioPageUserDefinedPageDto
}
/** Renders a studio page into a widget tree.

 The page will be rendered using the calling user's Studio authorization. The call may fail fully
 or partially if the user is not authorized to read the necessary data to render the page. */
SSRHook.clientEndpoints.push({ name: "postStudioPage", func: postStudioPage })
export async function postStudioPage(
    path: string,
    body: PostStudioPageRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostStudioPageDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/pages/${path}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostStudioPageError =
    | Forbidden
    | Unauthorized
    | JWTPropertyMissing
    | NotFound
    | BadRequest
    | Conflict
export function IsPostStudioPageError(e: any): e is PostStudioPageError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Forbidden" ||
            e.type === "Unauthorized" ||
            e.type === "JWTPropertyMissing" ||
            e.type === "NotFound" ||
            e.type === "BadRequest" ||
            e.type === "Conflict")
    )
}
export type PostStudioPageActionRequestBodyDto = WidgetRequest & {
    /** A key that uniquely identifies the widget within the page's widget tree that contains the
action to perform.*/
    widgetKey: string
    /** The action method to call. Defaults to `"action"` if unspecified.*/
    method?: string
    /** Arguments to the action function, if any*/
    args?: any[]
} & {
    /** If this a user-defined page, this is a potentially client-side-modified
version of the page code. This is used to preview the page before saving
it.*/
    previewCode?: TypeScript
}
/** Performs one of the predefined actions in a widget tree returned by `postStudioPage`.

This typically means "pushing a button" in the widget tree.

The action will be performed using the calling user's Studio authorization. This means that the
user must be authorized to perform all the implied consequences of the action for the call to be
successful. */
SSRHook.clientEndpoints.push({ name: "postStudioPageAction", func: postStudioPageAction })
export async function postStudioPageAction(
    path: string,
    body: PostStudioPageActionRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<WidgetActionResponse> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/pages/${path}/action`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostStudioPageActionError =
    | Forbidden
    | Unauthorized
    | JWTPropertyMissing
    | NotFound
    | BadRequest
    | Conflict
export function IsPostStudioPageActionError(e: any): e is PostStudioPageActionError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Forbidden" ||
            e.type === "Unauthorized" ||
            e.type === "JWTPropertyMissing" ||
            e.type === "NotFound" ||
            e.type === "BadRequest" ||
            e.type === "Conflict")
    )
}
export type PutUserDefinedStudioPageCodeRequestBodyDto = { code: TypeScript }
/** Allows updating the code of a user-defined studio page.

Implicitly requires permission to update the document through
StudioAuthorization. */
SSRHook.clientEndpoints.push({
    name: "putUserDefinedStudioPageCode",
    func: putUserDefinedStudioPageCode,
})
export async function putUserDefinedStudioPageCode(
    id: Uuid<"UserDefinedStudioPage">,
    body: PutUserDefinedStudioPageCodeRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/user-defined-page/${id}/code`,
            {
                method: "put",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type DocumentViewArgs = {
    version?: number
    /** The current state of the document on the client. This can be used to produce views for a
document that are currently being edited. If provided, this will be used instead of the
stored version. If provided, the `primaryKey` is ignored.*/
    clientState?: {
        /** The entire document in its client-local state.*/ document: any
        /** The original version of the document on which any changes are based.

If `null` set, this implies this is a new document that only exists on the client, not
yet saved in the database.*/
        originalVersion: null | number
    }
    state?: any
}
export type AddOperation<T0> = { op: "add"; value: any; path: string }
export type RemoveOperation = { op: "remove"; path: string }
export type ReplaceOperation<T0> = { op: "replace"; value: any; path: string }
export type MoveOperation = { op: "move"; from: string; path: string }
export type CopyOperation = { op: "copy"; from: string; path: string }
export type TestOperation<T0> = { op: "test"; value: any; path: string }
export type GetOperation<T0> = { op: "_get"; value: any; path: string }
export type Operation =
    | AddOperation<any>
    | RemoveOperation
    | ReplaceOperation<any>
    | MoveOperation
    | CopyOperation
    | TestOperation<any>
    | GetOperation<any>
export type ColorName =
    | "warning"
    | "error"
    | "gray"
    | "primary"
    | "success"
    | "gray-blue"
    | "gray-cool"
    | "gray-modern"
    | "gray-neutral"
    | "gray-iron"
    | "gray-true"
    | "gray-warm"
    | "moss"
    | "green-light"
    | "green"
    | "teal"
    | "cyan"
    | "blue-light"
    | "blue"
    | "blue-dark"
    | "indigo"
    | "violet"
    | "purple"
    | "fuchsia"
    | "pink"
    | "rosé"
    | "orange-dark"
    | "orange"
    | "yellow"
export type PostDocumentPageTabs1BadgeDto = { text: string; color: ColorName }
export type ReadyTab = {
    slug: string
    title: string
    content: Widget
    badge?: PostDocumentPageTabs1BadgeDto
}
export type Breadcrumb = { text: string; link?: string; icon?: string }
export type PostDocumentPageDto = {
    /** The requested document.

If the document corresponds to a document stored in the database, the stored form will
be returned.

If the document is a draft not yet stored in the database, the one provided in
`document` will be returned verbatim.*/
    document: any
    /** Whether the document is locked for editing.*/
    isLocked: boolean
    autoFillOperations: Operation[]
    /** The original version number of the document.

If no `clientState` was provided in the body, this is the current version of the
document on the server.

If `clientState` was provided, the client's version number is returned unchanged.*/
    originalVersion: undefined | null | number
    /** The version of this document currently held on the server. Can be compared to the local
originalVersion to detect editing conflicts and resolve them locally before saving.*/
    serverVersion: undefined | number
    /** Whether the user has permission to update this document. If a list of fields is
provided, the user is only allowed to update those particular fields.

If requesting a particular historical version, this will be `false`.*/
    canUpdate: string[] | boolean
    /** Whether the user has permission to delete this document.*/
    canDelete: boolean
    /** Whether the user has permission to bypass validation for this
document. If so, the Save-button will be enabled (with a danger cue and prompt) even if the document is invalid state.*/
    canBypassValidation: boolean
    /** The primary text from the widget representation of the document*/
    title: undefined | string
    /** Appropriate text to display underneath the primary title on the document page.

For singletons, this is the description of the singleton.
For collections, this is the display name of an item in the collection.*/
    subTitle: undefined | string
    /** Any chips that are appropriate to display next to the title.*/
    chips: undefined | Chip | Chip[]
    /** Table row representation of the document.*/
    row: WidgetMap
    /** Table row representations of all the referenced documents.*/
    refs: StudioRefTypes
    /** Available widget representations for different parts of the document*/
    widgets: StudioPropWidget
    /** Extra field sections defined by type extenders.*/
    typeExtensions: StudioTypeExtensions
    /** Available tabs for this document*/
    tabs: undefined | ReadyTab[]
    /** Values and widget representations for the options for various properties in the
document.*/
    options: StudioPropOptions
    /** Information about the files referenced in this document*/
    files: StudioFileInfo
    /** Whether this collection has a confirm changes widget that should
be presented to the user prior to saving changes.*/
    hasConfirmChanges: boolean
    /** Breadcrumbs that indicates a logical path to the current document.*/
    breadcrumbs: undefined | Breadcrumb[]
}
/** Returns a single document along with all associated widget representations, making it easier to
render the document in Studio without performing additional network requests. */
SSRHook.clientEndpoints.push({ name: "postDocumentPage", func: postDocumentPage })
export async function postDocumentPage(
    target: string,
    body: DocumentViewArgs,
    primaryKey?: string | number,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostDocumentPageDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (primaryKey !== undefined)
            queryArgs.push("primaryKey=" + encodeURIComponent(primaryKey.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/documents/${target}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostDocumentPageError = BadRequest | NotFound | Unauthorized | JWTPropertyMissing
export function IsPostDocumentPageError(e: any): e is PostDocumentPageError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadRequest" ||
            e.type === "NotFound" ||
            e.type === "Unauthorized" ||
            e.type === "JWTPropertyMissing")
    )
}
export const useDocumentPage = SSRHook<
    [
        target: string | null,
        body: DocumentViewArgs | null,
        primaryKey: (string | number) | null | undefined,
    ],
    PostDocumentPageDto
>(
    "postDocumentPage",
    "PostDocumentPageDto",
    undefined,
    postDocumentPage,
    ["target", "body", "primaryKey"],
    undefined
)
export type PostDocumentPageActionRequestBodyDto = DocumentViewArgs & {
    /** The action method to call. Defaults to `"action"` if unspecified.*/ method?: string
    /** Arguments to the action function, if any*/
    args?: any[]
}
/** Performs one of the predefined actions in a widget tree returned by
`postDocumentPage`.

This typically means "pushing a button" in the widget tree.

The action will be performed using the calling user's Studio authorization.
This means that the user must be authorized to perform all the implied
consequences of the action for the call to be successful.

To avoid subtle bugs, `body.clientState` must be used with caution, as the
action will be performed against the canonized version of the document, and
is not able to take any client-side state into account. The user should either
save or discard their client-side changes before performing an action.

`body.clientState` may be used when creating new documents. */
SSRHook.clientEndpoints.push({ name: "postDocumentPageAction", func: postDocumentPageAction })
export async function postDocumentPageAction(
    target: string,
    tab: string,
    widgetKey: string,
    body: PostDocumentPageActionRequestBodyDto,
    primaryKey?: string | number,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<WidgetActionResponse> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (tab !== undefined) queryArgs.push("tab=" + encodeURIComponent(tab.valueOf()))
        if (widgetKey !== undefined)
            queryArgs.push("widgetKey=" + encodeURIComponent(widgetKey.valueOf()))
        if (primaryKey !== undefined)
            queryArgs.push("primaryKey=" + encodeURIComponent(primaryKey.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/documents/page/${target}/action${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type DocumentMustBeSavedPriorToAction = {
    /** The type of this error, can be used for union discrimination*/
    type: "DocumentMustBeSavedPriorToAction"
    status: number
    detail: string
    stack?: string
}
export type PostDocumentPageActionError =
    | DocumentMustBeSavedPriorToAction
    | BadRequest
    | NotFound
    | Unauthorized
    | JWTPropertyMissing
export function IsPostDocumentPageActionError(e: any): e is PostDocumentPageActionError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "DocumentMustBeSavedPriorToAction" ||
            e.type === "BadRequest" ||
            e.type === "NotFound" ||
            e.type === "Unauthorized" ||
            e.type === "JWTPropertyMissing")
    )
}
export type PostDocumentDefaultsRequestBodyDto = { typeName: string }
SSRHook.clientEndpoints.push({ name: "postDocumentDefaults", func: postDocumentDefaults })
export async function postDocumentDefaults(
    body: PostDocumentDefaultsRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<any> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/documents/defaults`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type SerializedGraph = string
/** Returns information about the data collections managed by this server. */
SSRHook.clientEndpoints.push({ name: "getReflection", func: getReflection })
export async function getReflection(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<SerializedGraph> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/reflection`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.text()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useReflection = SSRHook<[], SerializedGraph>(
    "getReflection",
    "SerializedGraph",
    undefined,
    getReflection,
    [],
    undefined
)
/** Navigates to the link embedded in an email.

This registers the click in the database and redirects the user to the
link. */
SSRHook.clientEndpoints.push({ name: "getEmailLink", func: getEmailLink })
export async function getEmailLink(
    id: Uuid<"EmailLink">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/email/links/${id}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetEmailLinkError = NotFound | BadRequest
export function IsGetEmailLinkError(e: any): e is GetEmailLinkError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NotFound" || e.type === "BadRequest")
    )
}
export const useEmailLink = SSRHook<[id: Uuid<"EmailLink"> | null], void>(
    "getEmailLink",
    undefined,
    undefined,
    getEmailLink,
    ["id"],
    undefined
)
SSRHook.clientEndpoints.push({ name: "getLocales", func: getLocales })
export async function getLocales(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<Locale[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/locales`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useLocales = SSRHook<[], Locale[]>(
    "getLocales",
    undefined,
    undefined,
    getLocales,
    [],
    undefined
)
export type GetDefaultLocaleDto = { defaultLocale: LocaleKey }
SSRHook.clientEndpoints.push({ name: "getDefaultLocale", func: getDefaultLocale })
export async function getDefaultLocale(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetDefaultLocaleDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/default-locale`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useDefaultLocale = SSRHook<[], GetDefaultLocaleDto>(
    "getDefaultLocale",
    "GetDefaultLocaleDto",
    undefined,
    getDefaultLocale,
    [],
    undefined
)
export type GetEditingTemplatesTemplatesDto = {
    content: any
    id: Uuid<"EditingTemplate">
    /** The name of the template*/
    name: string
    /** The description of the template*/
    description?: string
    /** Typename of the template, e.g. "Section"*/
    type: string
}
export type GetEditingTemplatesDefaultsDto = { name: string; zoom: number; content: any }
export type GetEditingTemplatesDto = {
    templates: GetEditingTemplatesTemplatesDto[]
    defaults: GetEditingTemplatesDefaultsDto[]
}
/** Returns all available editing templates for a given type. */
SSRHook.clientEndpoints.push({ name: "getEditingTemplates", func: getEditingTemplates })
export async function getEditingTemplates(
    type: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetEditingTemplatesDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/editing-templates/${type}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useEditingTemplates = SSRHook<[type: string | null], GetEditingTemplatesDto>(
    "getEditingTemplates",
    "GetEditingTemplatesDto",
    undefined,
    getEditingTemplates,
    ["type"],
    undefined
)
export type PostEditingTemplateRequestBodyDto = { name: string; description?: string; content: any }
/** Creates a new editing template.

Returns an error if a template with the same name already exists for the given type */
SSRHook.clientEndpoints.push({ name: "postEditingTemplate", func: postEditingTemplate })
export async function postEditingTemplate(
    type: string,
    body: PostEditingTemplateRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/editing-templates/${type}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostEditingTemplateError = BadRequest
export function IsPostEditingTemplateError(e: any): e is PostEditingTemplateError {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest"
}
export type PutEditingTemplateRequestBodyDto = { name: string; description?: string; content: any }
/** Overwrites an existing editing template. */
SSRHook.clientEndpoints.push({ name: "putEditingTemplate", func: putEditingTemplate })
export async function putEditingTemplate(
    type: string,
    id: Uuid<"EditingTemplate">,
    body: PutEditingTemplateRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/editing-templates/${type}/${id}`,
            {
                method: "put",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
/** Deletes an editing template. */
SSRHook.clientEndpoints.push({ name: "deleteEditingTemplate", func: deleteEditingTemplate })
export async function deleteEditingTemplate(
    type: string,
    id: Uuid<"EditingTemplate">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/editing-templates/${type}/${id}`,
            {
                method: "delete",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PartialDataset = {
    [key: string]: {
        [key: string]: any
    }
}
export type PartialImportDocumentOptions = {
    /** What to do if the target collection has an existing document with the same primary key as
an imported document.

- `"overwrite"`: Keep the target document's primary key and overwrite all other
properties with the imported document's properties.
- `"keep-existing"`: Keep the target document as-is, change all references in the
imported document to point to the target document.*/
    existingPrimaryKey: "overwrite" | "keep-existing"
    /** What to do if the target collection has an existing document with the same `@title`
property value as an imported document.

- `"overwrite"`: Keep the target document's primary key and overwrite all other
properties with the imported document's properties.
- `"keep-existing"`: Keep the target document as-is, change all references in the
imported document to point to the target document.
- `"keep-both"`: Keep both documents. The imported documents will reference the imported
documents, and the target document will reference the existing documents.

Note that the following operator is not implemented yet due to its complexity:
- `"replace"`: Delete the existing (old) document, insert the imported document, and
update all references in the database to the old document to point to the new
document.*/
    existingTitle: "overwrite" | "keep-existing" | "keep-both"
}
export type PartialImportCollectionOptions = PartialImportDocumentOptions & {
    /** Specifies document-specific overrides of the resolution options.*/
    optionsPerDocument?: {
        [key: string]: PartialImportDocumentOptions
    }
}
export type PartialImportOptions = {
    [key: string]: PartialImportCollectionOptions
}
export type PostDatasetPartialPreviewRequestBodyDto = {
    partialDataset: PartialDataset
    options: PartialImportOptions
}
export type PostDatasetPartialPreviewEffectAdditionalPropsKeepExistingDto = {
    existingDoc: any
    newDoc: any
    existingWidget: Widget
    newWidget: Widget
}
export type PostDatasetPartialPreviewEffectAdditionalPropsOverwriteDto = {
    existingDoc: any
    newDoc: any
    existingWidget: Widget
    newWidget: Widget
}
export type PostDatasetPartialPreviewEffectAdditionalPropsInsertDto = {
    newDoc: any
    newWidget: Widget
}
export type CollectionImportEffect = {
    keepExisting: PostDatasetPartialPreviewEffectAdditionalPropsKeepExistingDto[]
    overwrite: PostDatasetPartialPreviewEffectAdditionalPropsOverwriteDto[]
    insert: PostDatasetPartialPreviewEffectAdditionalPropsInsertDto[]
}
export type PostDatasetPartialPreviewEffectDto = {
    [key: string]: CollectionImportEffect
}
export type PostDatasetPartialPreviewFilesToImportDto = {
    [key: string]: string
}
export type PostDatasetPartialPreviewDto = {
    /** Can be sent back to `postDatasetPartial` to verify that the previewed effect has not
changed.*/
    hash: string
    effect: PostDatasetPartialPreviewEffectDto
    filesToImport: PostDatasetPartialPreviewFilesToImportDto
    filesAlreadyImported: string[]
    /** If `"commit-async"` is specified, this is the handle of the background import process
that can be inspected through the API.*/
    importId: Uuid<"PartialDatasetImport">
}
/** Previews what will happen if a partial dataset is imported with the given settings. */
SSRHook.clientEndpoints.push({ name: "postDatasetPartialPreview", func: postDatasetPartialPreview })
export async function postDatasetPartialPreview(
    body: PostDatasetPartialPreviewRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostDatasetPartialPreviewDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/dataset/partial/preview`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostDatasetPartialPreviewError = Unauthorized | JWTPropertyMissing
export function IsPostDatasetPartialPreviewError(e: any): e is PostDatasetPartialPreviewError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Unauthorized" || e.type === "JWTPropertyMissing")
    )
}
export type PostDatasetPartialRequestBodyDto = {
    partialDataset: PartialDataset
    /** Options for how to handle conflicts on per-collection or per-document level.*/
    options: PartialImportOptions
    /** A reason for the import, to be logged on the resulting events*/
    reason?: string
    /** If provided, the commit will only happen if the effect is identical to the provided effect
(which was typically previewed to the user)*/
    assertHash?: string
    /** Ignores file imports. This is primarily for testing purposes, as it may leave the dataset in
an inconsisten state. If this flag is true, this endpoint returns synchronously with changes
committed.*/
    ignoreFiles?: boolean
}
export type PostDatasetPartialEffectDto = {
    [key: string]: CollectionImportEffect
}
export type PostDatasetPartialFilesToImportDto = {
    [key: string]: string
}
export type PostDatasetPartialDto = {
    effect: PostDatasetPartialEffectDto
    filesToImport: PostDatasetPartialFilesToImportDto
    filesAlreadyImported: string[]
    /** If `"commit-async"` is specified, this is the handle of the background import process
that can be inspected through the API.*/
    importId: Uuid<"PartialDatasetImport">
}
/** Imports a partial dataset.

 The dataset will be downloaded asynchronously. You can poll `GET
 /studio/dataset/partial/:id/status` to get the progress. */
SSRHook.clientEndpoints.push({ name: "postDatasetPartial", func: postDatasetPartial })
export async function postDatasetPartial(
    body: PostDatasetPartialRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostDatasetPartialDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/dataset/partial`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostDatasetPartialError = Conflict | Unauthorized | JWTPropertyMissing
export function IsPostDatasetPartialError(e: any): e is PostDatasetPartialError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Conflict" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing")
    )
}
/** Holds a record of an ongoing or completed partial dataset import. */
export type PartialDatasetImportFileStatus =
    | "waiting"
    | "complete"
    | "downloading"
    | "uploading"
    | "uploaded"
    | "failed"
export type GetDatasetPartialStatusFilesDto = {
    id: string
    url: Url
    filename?: string
    mimetype?: string
    status: PartialDatasetImportFileStatus
    error?: string
}
export type PartialDatasetImport = {
    id: Uuid<"PartialDatasetImport">
    reason?: string
    /** The status of each of the files being imported*/
    files: GetDatasetPartialStatusFilesDto[]
    /** - "ongoing" : Currently importing binary files
- "committing" : Currently attempting to commit changeset to database
- "failed" : Something went wrong, see `error`
- "complete" : Import completed successfully*/
    status: "failed" | "ongoing" | "committing" | "completed"
    error?: string
}
SSRHook.clientEndpoints.push({ name: "getDatasetPartialStatus", func: getDatasetPartialStatus })
export async function getDatasetPartialStatus(
    importId: Uuid<"PartialDatasetImport">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PartialDatasetImport> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/dataset/partial/${importId}/status`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useDatasetPartialStatus = SSRHook<
    [importId: Uuid<"PartialDatasetImport"> | null],
    PartialDatasetImport
>(
    "getDatasetPartialStatus",
    "PartialDatasetImport",
    undefined,
    getDatasetPartialStatus,
    ["importId"],
    undefined
)
export type PostStudioTranslateRequestBodyDto = {
    /** The object to translate.*/ object: any
    /** The type name of the provided object.

This will be used to find the Localized<T> nodes.

The following types for T will be translated:
- `string`
- `Markdown`*/
    typeName: string
    /** The locales to translate to. All localized strings in the object will be
translated to these locales, if they are not already translated.

If undefined, all studio locales will be used.*/
    locales?: LocaleKey[]
    /** The locale to use as the preferred source for translations, if available.
If undefined, "en" will be used.*/
    authoritativeLocale?: LocaleKey
}
export type PostStudioTranslateTranslationsTranslationsDto = {
    dst: LocaleKey
    dstFlag: string
    value: string
}
export type PostStudioTranslateTranslationsDto = {
    path: string[]
    original: string
    src: LocaleKey
    srcFlag: string
    type?: "Markdown"
    multiline: boolean
    translations: PostStudioTranslateTranslationsTranslationsDto[]
}
export type PostStudioTranslateDto = {
    translations: PostStudioTranslateTranslationsDto[]
    flags: string[]
}
SSRHook.clientEndpoints.push({ name: "postStudioTranslate", func: postStudioTranslate })
export async function postStudioTranslate(
    body: PostStudioTranslateRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostStudioTranslateDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/translate`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostStudioTranslateError = NotFound
export function IsPostStudioTranslateError(e: any): e is PostStudioTranslateError {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound"
}
export type GetMarkdownSnippetDto = {
    id: Uuid<"MarkdownSnippet">
    /** The name of the snippet.*/
    name: Localized<string>
    /** The snippet content.*/
    snippet: Localized<Markdown>
    /** Contains the snippet content with all embedded snippets expanded.*/
    hydratedSnippet: Localized<Markdown>
}
SSRHook.clientEndpoints.push({ name: "getMarkdownSnippet", func: getMarkdownSnippet })
export async function getMarkdownSnippet(
    id: Uuid<"MarkdownSnippet">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetMarkdownSnippetDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/markdown-snippets/${id}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useMarkdownSnippet = SSRHook<
    [id: Uuid<"MarkdownSnippet"> | null],
    GetMarkdownSnippetDto
>(
    "getMarkdownSnippet",
    "GetMarkdownSnippetDto",
    "PutMarkdownSnippetRequestBodyDto",
    getMarkdownSnippet,
    ["id"],
    (args, body) => putMarkdownSnippet.apply(null, [args[0], body] as any)
)
export type PutMarkdownSnippetRequestBodyDto = {
    name: Localized<string>
    snippet: Localized<Markdown>
}
SSRHook.clientEndpoints.push({ name: "putMarkdownSnippet", func: putMarkdownSnippet })
export async function putMarkdownSnippet(
    id: Uuid<"MarkdownSnippet">,
    body: PutMarkdownSnippetRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/markdown-snippets/${id}`,
            {
                method: "put",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type StudioMenuItem = {
    /** The FontAwesome icon name, e.g. `"camera"`*/ icon?: string
    isDefault?: boolean
    /** The slug of the target page or name of collection*/
    target?: string
    menu?: StudioMenu
    dock?: "bottom"
    /** If specified, this overrides the index of this menu item in the menu order*/
    index?: number
    /** If true, this menu item will have some extra space before it next bottom neighbor.*/
    spacingBottom?: boolean
}
export type StudioMenu = {
    [key: string]: StudioMenuItem
}
export type GetStudioMenuScopesOptionsDto = { value: any; display: string }
export type GetStudioMenuScopesDto = {
    /** A unique handle for this scope, to be used with the scope API.*/ slug: string
    /** Display name of this scope.*/
    name: string
    /** The available options for this scope for the current user*/
    options: GetStudioMenuScopesOptionsDto[]
    /** The currently selected value for this scope for the current user.*/
    value: any
}
export type GetStudioMenuDto = {
    menu: StudioMenu
    studioMenu: StudioMenu
    scopes: GetStudioMenuScopesDto[]
}
/** Returns the studio menu for the current user. */
SSRHook.clientEndpoints.push({ name: "getStudioMenu", func: getStudioMenu })
export async function getStudioMenu(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetStudioMenuDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/menu`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetStudioMenuError = Unauthorized | JWTPropertyMissing
export function IsGetStudioMenuError(e: any): e is GetStudioMenuError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Unauthorized" || e.type === "JWTPropertyMissing")
    )
}
export const useStudioMenu = SSRHook<[], GetStudioMenuDto>(
    "getStudioMenu",
    "GetStudioMenuDto",
    undefined,
    getStudioMenu,
    [],
    undefined
)
export type PutStudioMenuScopeRequestBodyDto = { value: any }
/** Sets the current scope selection for the current user.

This typically stores the preference in a cookie for subsequent requests. */
SSRHook.clientEndpoints.push({ name: "putStudioMenuScope", func: putStudioMenuScope })
export async function putStudioMenuScope(
    slug: string,
    body: PutStudioMenuScopeRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/menu/scope/${slug}`,
            {
                method: "put",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PutStudioMenuScopeError = NotFound | BadRequest
export function IsPutStudioMenuScopeError(e: any): e is PutStudioMenuScopeError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NotFound" || e.type === "BadRequest")
    )
}
/** Downloads the primary dataset from this Reactor instance.

This includes all collection data marked as `isPrimaryDataset`. */
SSRHook.clientEndpoints.push({ name: "getPrimaryDataset", func: getPrimaryDataset })
export async function getPrimaryDataset(
    includeFiles: boolean,
    secret: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<string> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (includeFiles !== undefined)
            queryArgs.push("includeFiles=" + encodeURIComponent(includeFiles.valueOf()))
        if (secret !== undefined) queryArgs.push("secret=" + encodeURIComponent(secret.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/primary-dataset${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.text()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetPrimaryDatasetError = Forbidden
export function IsGetPrimaryDatasetError(e: any): e is GetPrimaryDatasetError {
    return e && typeof e === "object" && "type" in e && e.type === "Forbidden"
}
export const usePrimaryDataset = SSRHook<
    [includeFiles: boolean | null, secret: string | null],
    string
>(
    "getPrimaryDataset",
    undefined,
    undefined,
    getPrimaryDataset,
    ["includeFiles", "secret"],
    undefined
)
SSRHook.clientEndpoints.push({ name: "postPrimaryDataset", func: postPrimaryDataset })
export async function postPrimaryDataset(
    files: any[],
    secret: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (secret !== undefined) queryArgs.push("secret=" + encodeURIComponent(secret.valueOf()))

        const formData = new FormData()

        for (const file of files) {
            formData.append("file", file)
        }

        const headers = { ...defaults.headers, ...customHeaders }
        delete headers["Content-Type"]
        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/primary-dataset${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "post",
                headers,
                body: formData,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostPrimaryDatasetError = BadRequest | Forbidden
export function IsPostPrimaryDatasetError(e: any): e is PostPrimaryDatasetError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadRequest" || e.type === "Forbidden")
    )
}
export type UserClaims = {
    /** The method used to perform this action. This is intended to help
humans understand why/how this happened. Can e.g. be the name of the
endpoint used, name of example rendered or the name of an action
invoked from the UI.*/
    method?: string
    /** The verified email address of the user that performed this action.*/
    email?: string
    /** If multiple users contributed to this action, this field contains the
email addresses of those users.*/
    emails?: string[]
    /** A textual explanation for why this action was performed, to help
humans understand the event history. Should be of the form that
works after "because", e.g. "a isDraft field was added to the data
model"*/
    reason?: string
    /** The textual reason for the Collection-rules that were enforced on
top of the direct changes. Used to help humans inspecting the event
history understand why the patch was modified compared to the
user-initiated changes.*/
    enforcedRules?: string[]
    /** If set to `true` on an `Insert` event, this indicates that this event is not necessarily an
insert of a new document, but marks a rewrite of the event stream for an existing document.
When streaming events, this means the in-memory document needs to be replaced with the
provided payload. If the event stream contains an earlier insert for the same primary key, it
retains its original created date.*/
    rewrite?: boolean
    /** If set to `true` on a `Delete` event, this indicates the document has had its entire event
history deleted. Any in-memory caches must evict this document and forget it ever existed.*/
    purge?: boolean
}
export type EventBase = {
    /** The version number of the event.*/ version: number
    /** When this event happened, as recorded by the acting agent.

The database may have canonized this event at a later time.*/
    timestamp: number
    /** Claims about the user that performed this action, including how and why.

This information is primarily used to help humans inspecting the event
history understand who, why and how this action was performed.

This object can contain arbitrary fields of useful meta data, in
addition to the documented ones.*/
    userClaims: UserClaims
    /** The primary key, or keys, of the document being affected.

In the case of a single primary key, the `.toString()` of the key is
used.

In the case of multiple primary keys, a stringified JSON object is used.
The JSON payload must be without redundant white spaces, and keys must be
in the exact order declared in the model.*/
    key: string
    /** Rendered title of the document. This field is derived state, only
populated by some endpoints, and is not stored in the database.*/
    title?: string
    /** The studio user corresponding to `userClaims.email`, if such a user
exists. This field is derived state, only populated by some endpoints,
and is not stored in the database.*/
    studioUser?: StudioUser
}
export type GetDocumentEventsDraftEvents1Insert1Dto = { type: "Insert"; document: unknown }
export type Insert = EventBase & GetDocumentEventsDraftEvents1Insert1Dto
export type GetDocumentEventsDraftEvents1Remove1Dto = { type: "Remove" }
export type Remove = EventBase & GetDocumentEventsDraftEvents1Remove1Dto
export type GetDocumentEventsDraftEvents1Update1Dto = { type: "Update"; operations: Operation[] }
export type Update = EventBase & GetDocumentEventsDraftEvents1Update1Dto
export type Event = Insert | Remove | Update
export type GetDocumentEventsEventsInsertDto = {
    parentWidgets: undefined | Widget[]
    widgets: undefined | Widget[]
    studioUser: undefined | StudioUser
    /** The version number of the event.*/
    version: number
    /** When this event happened, as recorded by the acting agent.

The database may have canonized this event at a later time.*/
    timestamp: number
    /** Claims about the user that performed this action, including how and why.

This information is primarily used to help humans inspecting the event
history understand who, why and how this action was performed.

This object can contain arbitrary fields of useful meta data, in
addition to the documented ones.*/
    userClaims: UserClaims
    /** The primary key, or keys, of the document being affected.

In the case of a single primary key, the `.toString()` of the key is
used.

In the case of multiple primary keys, a stringified JSON object is used.
The JSON payload must be without redundant white spaces, and keys must be
in the exact order declared in the model.*/
    key: string
    /** Rendered title of the document. This field is derived state, only
populated by some endpoints, and is not stored in the database.*/
    title?: string
    type: "Insert"
    document: unknown
}
export type GetDocumentEventsEventsRemoveDto = {
    parentWidgets: undefined | Widget[]
    widgets: undefined | Widget[]
    studioUser: undefined | StudioUser
    /** The version number of the event.*/
    version: number
    /** When this event happened, as recorded by the acting agent.

The database may have canonized this event at a later time.*/
    timestamp: number
    /** Claims about the user that performed this action, including how and why.

This information is primarily used to help humans inspecting the event
history understand who, why and how this action was performed.

This object can contain arbitrary fields of useful meta data, in
addition to the documented ones.*/
    userClaims: UserClaims
    /** The primary key, or keys, of the document being affected.

In the case of a single primary key, the `.toString()` of the key is
used.

In the case of multiple primary keys, a stringified JSON object is used.
The JSON payload must be without redundant white spaces, and keys must be
in the exact order declared in the model.*/
    key: string
    /** Rendered title of the document. This field is derived state, only
populated by some endpoints, and is not stored in the database.*/
    title?: string
    type: "Remove"
}
export type GetDocumentEventsEventsUpdateDto = {
    parentWidgets: undefined | Widget[]
    widgets: undefined | Widget[]
    studioUser: undefined | StudioUser
    /** The version number of the event.*/
    version: number
    /** When this event happened, as recorded by the acting agent.

The database may have canonized this event at a later time.*/
    timestamp: number
    /** Claims about the user that performed this action, including how and why.

This information is primarily used to help humans inspecting the event
history understand who, why and how this action was performed.

This object can contain arbitrary fields of useful meta data, in
addition to the documented ones.*/
    userClaims: UserClaims
    /** The primary key, or keys, of the document being affected.

In the case of a single primary key, the `.toString()` of the key is
used.

In the case of multiple primary keys, a stringified JSON object is used.
The JSON payload must be without redundant white spaces, and keys must be
in the exact order declared in the model.*/
    key: string
    /** Rendered title of the document. This field is derived state, only
populated by some endpoints, and is not stored in the database.*/
    title?: string
    type: "Update"
    operations: Operation[]
}
export type GetDocumentEventsDto = {
    draftEvents: undefined | Event[]
    events: (
        | GetDocumentEventsEventsInsertDto
        | GetDocumentEventsEventsRemoveDto
        | GetDocumentEventsEventsUpdateDto
    )[]
    totalCount: number
}
SSRHook.clientEndpoints.push({ name: "getDocumentEvents", func: getDocumentEvents })
export async function getDocumentEvents(
    collection: string,
    document: string,
    count: number,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetDocumentEventsDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (collection !== undefined)
            queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()))
        if (document !== undefined)
            queryArgs.push("document=" + encodeURIComponent(document.valueOf()))
        if (count !== undefined) queryArgs.push("count=" + encodeURIComponent(count.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/documents/events${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetDocumentEventsError = BadRequest | NotFound | Unauthorized | Forbidden
export function IsGetDocumentEventsError(e: any): e is GetDocumentEventsError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadRequest" ||
            e.type === "NotFound" ||
            e.type === "Unauthorized" ||
            e.type === "Forbidden")
    )
}
export const useDocumentEvents = SSRHook<
    [collection: string | null, document: string | null, count: number | null],
    GetDocumentEventsDto
>(
    "getDocumentEvents",
    "GetDocumentEventsDto",
    undefined,
    getDocumentEvents,
    ["collection", "document", "count"],
    undefined
)
export type PostStudioGlobalSearchRequestBodyDto = { state: any }
export type PostStudioGlobalSearchCountsDto = {
    [key: string]: number
}
export type PostStudioGlobalSearchDto = {
    /** How many hit documents, per collection*/ counts: PostStudioGlobalSearchCountsDto
    content: Widget
}
/** Searches all collections that the current user has read and filter access to, and renders a
widget page with one table for each collection containing hits. */
SSRHook.clientEndpoints.push({ name: "postStudioGlobalSearch", func: postStudioGlobalSearch })
export async function postStudioGlobalSearch(
    searchString: string,
    body: PostStudioGlobalSearchRequestBodyDto,
    searchCollection?: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostStudioGlobalSearchDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (searchString !== undefined)
            queryArgs.push("searchString=" + encodeURIComponent(searchString.valueOf()))
        if (searchCollection !== undefined)
            queryArgs.push("searchCollection=" + encodeURIComponent(searchCollection.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/search${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostStudioGlobalSearchError = Forbidden | NotFound | BadRequest | Conflict
export function IsPostStudioGlobalSearchError(e: any): e is PostStudioGlobalSearchError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Forbidden" ||
            e.type === "NotFound" ||
            e.type === "BadRequest" ||
            e.type === "Conflict")
    )
}
export const useStudioGlobalSearch = SSRHook<
    [
        searchString: string | null,
        body: PostStudioGlobalSearchRequestBodyDto | null,
        searchCollection: string | null | undefined,
    ],
    PostStudioGlobalSearchDto
>(
    "postStudioGlobalSearch",
    "PostStudioGlobalSearchDto",
    undefined,
    postStudioGlobalSearch,
    ["searchString", "body", "searchCollection"],
    undefined
)
SSRHook.clientEndpoints.push({ name: "getSendMailTrackingPixel", func: getSendMailTrackingPixel })
export async function getSendMailTrackingPixel(
    id: Uuid<"SentMail">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<
    | undefined
    | "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/email-read/${id}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetSendMailTrackingPixelError = NotFound | Unauthorized | JWTPropertyMissing
export function IsGetSendMailTrackingPixelError(e: any): e is GetSendMailTrackingPixelError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NotFound" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing")
    )
}
export const useSendMailTrackingPixel = SSRHook<
    [id: Uuid<"SentMail"> | null],
    | undefined
    | "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
>("getSendMailTrackingPixel", undefined, undefined, getSendMailTrackingPixel, ["id"], undefined)
export type StudioToast = {
    id: Uuid<"StudioToast">
    /** The user that should receive this toast.*/
    user: Email
    message: Markdown
    type: EmptyVariant | "Warning" | "Info"
}
/** Returns the studio toasts for the current user. */
SSRHook.clientEndpoints.push({ name: "getStudioToasts", func: getStudioToasts })
export async function getStudioToasts(
    offset?: number,
    limit?: number,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<StudioToast[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (offset !== undefined) queryArgs.push("offset=" + encodeURIComponent(offset.valueOf()))
        if (limit !== undefined) queryArgs.push("limit=" + encodeURIComponent(limit.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/toasts${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetStudioToastsError = Unauthorized | JWTPropertyMissing
export function IsGetStudioToastsError(e: any): e is GetStudioToastsError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Unauthorized" || e.type === "JWTPropertyMissing")
    )
}
export const useStudioToasts = SSRHook<
    [offset: number | null | undefined, limit: number | null | undefined],
    StudioToast[]
>("getStudioToasts", undefined, undefined, getStudioToasts, ["offset", "limit"], undefined)
/** Deletes a studio toast.

This is typically called when the user dismisses the toast. */
SSRHook.clientEndpoints.push({ name: "deleteStudioToast", func: deleteStudioToast })
export async function deleteStudioToast(
    id: Uuid<"StudioToast">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/toasts/${id}`,
            {
                method: "delete",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type DeleteStudioToastError = Unauthorized | JWTPropertyMissing
export function IsDeleteStudioToastError(e: any): e is DeleteStudioToastError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Unauthorized" || e.type === "JWTPropertyMissing")
    )
}
export type AnalyticsEventStatus = {
    /** The type of event that was checked.

If all events are disabled, this will not be specified.*/
    type?: string
    /** The ID of the event type that was checked.

If all events are disabled, this will not be specified.*/
    eventType?: Int
    /** Whether the event is disabled.

If `true`, the particular event type is disabled.
If `"all"`, all events are disabled.*/
    disabled: "all" | boolean
}
/** Returns whether a particular analytics event is enabled.

If an event is disbaled, the clients should not bother sending it.

This is intended to be used during SSR to built into the SPA whether to
send certain analytics events or not. */
SSRHook.clientEndpoints.push({ name: "getAnalyticsEventStatus", func: getAnalyticsEventStatus })
export async function getAnalyticsEventStatus(
    type: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<AnalyticsEventStatus> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/analytics-events/${type}/status`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useAnalyticsEventStatus = SSRHook<[type: string | null], AnalyticsEventStatus>(
    "getAnalyticsEventStatus",
    "AnalyticsEventStatus",
    undefined,
    getAnalyticsEventStatus,
    ["type"],
    undefined
)
export type PostAnalyticsEventRequestBodyDto = {
    /** An array of up to four entity scopes, each up to 255 characters.

These are arbitrary strings that can be used to identify the entity
that the event is related to. Can be used for arbitrary purposes.

To make the data the most useful, the first scope should be the most
significant / most general, and the last scope the least significant /
most specific.

For example, an URL path could be split into scopes like this:

URL: `/shop/product/1234/reviews`
Scopes: `["shop", "product", "1234", "reviews"]`*/
    entity?: string[]
    /** An arbitrary JSON object with additional data.

This should be used sparingly, and only for data that is not easily
represented in the entity scopes.

For example, frequently used query parameters could be included in
the entity scopes. Less frequently used query parameters could be
included in the data object.

The data column may not be indexed, so it is not suitable for
frequently queried data.

Maximum length of the data payload when serialized to JSON is 1000
characters.*/
    data?: any
}
export type PostAnalyticsEvent1Dto = {
    /** Auto-generated ID of the event.

This is an auto-incrementing integer, to save space in the database.*/
    id: Int
}
/** Logs an analytics event.

Mobile apps should set two additional headers:
`Fuse-Install-Id` and `Fuse-App-Version`. */
SSRHook.clientEndpoints.push({ name: "postAnalyticsEvent", func: postAnalyticsEvent })
export async function postAnalyticsEvent(
    type: string,
    body: PostAnalyticsEventRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<AnalyticsEventStatus | PostAnalyticsEvent1Dto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/analytics-events/${type}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostAnalyticsEventError = BadRequest | Unauthorized | JWTPropertyMissing
export function IsPostAnalyticsEventError(e: any): e is PostAnalyticsEventError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadRequest" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing")
    )
}
export type PostSharedWidgetRequestBodyDto = { state: any }
export type PostSharedWidgetDto = {
    /** The state of the widgets to render*/ defaultState: any
    content: Widget[]
}
SSRHook.clientEndpoints.push({ name: "postSharedWidget", func: postSharedWidget })
export async function postSharedWidget(
    urlSecret: Uuid<"UrlSecret">,
    body: PostSharedWidgetRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostSharedWidgetDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/shared-widget/${urlSecret}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostSharedWidgetError = Unauthorized | BadRequest | NotFound | JWTPropertyMissing
export function IsPostSharedWidgetError(e: any): e is PostSharedWidgetError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Unauthorized" ||
            e.type === "BadRequest" ||
            e.type === "NotFound" ||
            e.type === "JWTPropertyMissing")
    )
}
export const useSharedWidget = SSRHook<
    [urlSecret: Uuid<"UrlSecret"> | null, body: PostSharedWidgetRequestBodyDto | null],
    PostSharedWidgetDto
>(
    "postSharedWidget",
    "PostSharedWidgetDto",
    undefined,
    postSharedWidget,
    ["urlSecret", "body"],
    undefined
)
export type GetLayerUpdatesDto = {
    /** Whether the document exists or not. If this is false, the document is
an uncreated draft that only exists as a set of uncommitted updates.*/
    exists: boolean
    /** The latest version number of the document. This is the highest version
number of all operations in the layer.*/
    version: Int
    /** The operations in the layer, starting from the given version. The
client should apply these changes to their local document to get up
to speed.*/
    ops: string[]
}
/** Returns the updates in the given layer for the given document, from the given
version.

In order to call this endpoint, the user must have read access to the
document.

If the document doesn't exist yet, but represents an uncreated (draft)
document, the user must have insert access to the collection. */
SSRHook.clientEndpoints.push({ name: "getLayerUpdates", func: getLayerUpdates })
export async function getLayerUpdates(
    res: string,
    key: string,
    layer: string,
    version: Int,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetLayerUpdatesDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (version !== undefined)
            queryArgs.push("version=" + encodeURIComponent(version.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/layers/${res}/${key}/${layer}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetLayerUpdatesError = Forbidden | NotFound | Unauthorized
export function IsGetLayerUpdatesError(e: any): e is GetLayerUpdatesError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Forbidden" || e.type === "NotFound" || e.type === "Unauthorized")
    )
}
export const useLayerUpdates = SSRHook<
    [res: string | null, key: string | null, layer: string | null, version: Int | null],
    GetLayerUpdatesDto
>(
    "getLayerUpdates",
    "GetLayerUpdatesDto",
    undefined,
    getLayerUpdates,
    ["res", "key", "layer", "version"],
    undefined
)
export type PostLayerUpdatesRequestBodyDto = {
    /** Base64 encoded Yjs update operation.*/ data: string
    clientId: Uuid<"Uuid">
    version: Int
}
export type PostLayerUpdatesDto = {
    /** Whether the document exists or not. If this is false, the document is
an uncreated draft that only exists as a set of uncommitted updates.*/
    exists: boolean
    /** The latest version number of the document. This is the highest version
number of all operations in the layer.*/
    version: Int
    /** The operations in the layer, starting from the given version. The
client should apply these changes to their local document to get up
to speed.*/
    ops: string[]
    status: string
}
/** Posts a new operation to the given document in the given layer.

If the document doesn't exist yet, but represents an uncreated (draft)
document, the user must have insert access to the collection.

If the document exists, the user must have update access to the document. */
SSRHook.clientEndpoints.push({ name: "postLayerUpdates", func: postLayerUpdates })
export async function postLayerUpdates(
    res: string,
    key: string,
    layer: string,
    body: PostLayerUpdatesRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostLayerUpdatesDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/layers/${res}/${key}/${layer}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostLayerUpdatesError = Forbidden | NotFound | Unauthorized | JWTPropertyMissing
export function IsPostLayerUpdatesError(e: any): e is PostLayerUpdatesError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Forbidden" ||
            e.type === "NotFound" ||
            e.type === "Unauthorized" ||
            e.type === "JWTPropertyMissing")
    )
}
/** Deletes all updates in the given layer.

For uncreated drafts, this will effectively delete the draft, since it only
exists as uncommitted updates.

For existing documents, this will delete all updates in the given layer (i.e.
unpublished changes). The published document will be unaffected.

For existing documents, the user must have update access to the document to
discard the updates.

For uncreated drafts, the user must have insert access to the collection to
discard the uncreated draft. */
SSRHook.clientEndpoints.push({ name: "discardLayerUpdates", func: discardLayerUpdates })
export async function discardLayerUpdates(
    res: string,
    key: string,
    layer: string,
    clientId: Uuid<"Uuid">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (clientId !== undefined)
            queryArgs.push("clientId=" + encodeURIComponent(clientId.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/layers/${res}/${key}/${layer}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "delete",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type DiscardLayerUpdatesError = Forbidden | NotFound | Conflict
export function IsDiscardLayerUpdatesError(e: any): e is DiscardLayerUpdatesError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Forbidden" || e.type === "NotFound" || e.type === "Conflict")
    )
}
export type MergeLayerDto = { newVersion?: number; newDocument?: any; isCollection?: boolean }
/** Saves the operations in the given layer into the base layer, and updates the
target document. */
SSRHook.clientEndpoints.push({ name: "mergeLayer", func: mergeLayer })
export async function mergeLayer(
    res: string,
    key: string,
    layer: string,
    clientId: Uuid<"Uuid">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<MergeLayerDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (clientId !== undefined)
            queryArgs.push("clientId=" + encodeURIComponent(clientId.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/studio/layers/${res}/${key}/${layer}/merge${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "post",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type MergeLayerError =
    | BadRequest
    | Forbidden
    | NotFound
    | Unauthorized
    | Conflict
    | JWTPropertyMissing
export function IsMergeLayerError(e: any): e is MergeLayerError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadRequest" ||
            e.type === "Forbidden" ||
            e.type === "NotFound" ||
            e.type === "Unauthorized" ||
            e.type === "Conflict" ||
            e.type === "JWTPropertyMissing")
    )
}
export type WebPage = {
    id: Uuid<"WebPage">
    /** The page's title, as displayed in the browser's title bar and search engines.

Note that appearance in search engine results are subject to the internals of the search
engine. They typically display a maximum of 60 characters, and will cut off the title if
it is too long.*/
    title: Localized<string>
    /** The description of the page, for displaying in search engines underneath the title.*/
    description?: Localized<string>
    /** URL slug that will direct to this page. Leave unset for home page. No leading slash.*/
    slug?: Localized<string>
    /** Whether this page is published.
Non-published pages can only be viewed by Studio users with sufficient permissions.*/
    published: boolean
    /** Redirect to this path or URL.*/
    redirect?: string
    /** The parent page, if applicable. This enables breadcrumbs and other navigation features.*/
    parent?: Uuid<"WebPage">
    /** The page's content.*/
    sections: Section[]
}
export type GetWebPageBreadcrumbDto = {
    id: Uuid<"WebPage">
    /** The page's title, as displayed in the browser's title bar and search engines.

Note that appearance in search engine results are subject to the internals of the search
engine. They typically display a maximum of 60 characters, and will cut off the title if
it is too long.*/
    title: Localized<string>
    /** URL slug that will direct to this page. Leave unset for home page. No leading slash.*/
    slug: undefined | Localized<string>
}
export type GetWebPageDto = {
    page: WebPage
    /** Information about the parent pages of the current page.

This includes the current page at slot [0], the first parent at slot [1], and so on.*/
    breadcrumb: GetWebPageBreadcrumbDto[]
}
SSRHook.clientEndpoints.push({ name: "getWebPage", func: getWebPage })
export async function getWebPage(
    locale: LocaleKey,
    slug?: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetWebPageDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (locale !== undefined) queryArgs.push("locale=" + encodeURIComponent(locale.valueOf()))
        if (slug !== undefined) queryArgs.push("slug=" + encodeURIComponent(slug.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/web/page${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetWebPageError = NotFound
export function IsGetWebPageError(e: any): e is GetWebPageError {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound"
}
export const useWebPage = SSRHook<
    [locale: LocaleKey | null, slug: string | null | undefined],
    GetWebPageDto
>("getWebPage", "GetWebPageDto", undefined, getWebPage, ["locale", "slug"], undefined)
export type GetWebPageInfoDto = {
    /** The page's title, as displayed in the browser's title bar and search engines.

Note that appearance in search engine results are subject to the internals of the search
engine. They typically display a maximum of 60 characters, and will cut off the title if
it is too long.*/
    title: Localized<string>
    /** URL slug that will direct to this page. Leave unset for home page. No leading slash.*/
    slug: undefined | Localized<string>
}
/** Returns info about a web page by its ID.

This is useful if you don't have the slug of the page, but you know its ID. */
SSRHook.clientEndpoints.push({ name: "getWebPageInfo", func: getWebPageInfo })
export async function getWebPageInfo(
    id: Uuid<"WebPage">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetWebPageInfoDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/web/page-info/${id}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useWebPageInfo = SSRHook<[id: Uuid<"WebPage"> | null], GetWebPageInfoDto>(
    "getWebPageInfo",
    "GetWebPageInfoDto",
    undefined,
    getWebPageInfo,
    ["id"],
    undefined
)
export type GetWebPagesInfos = { ids: null | (null | Uuid<"WebPage">)[] }
export type PostWebPagesInfos11Dto = {
    /** The page's title, as displayed in the browser's title bar and search engines.

Note that appearance in search engine results are subject to the internals of the search
engine. They typically display a maximum of 60 characters, and will cut off the title if
it is too long.*/
    title: Localized<string>
    /** URL slug that will direct to this page. Leave unset for home page. No leading slash.*/
    slug: undefined | Localized<string>
}
/** Validates, checks avaialbility and calculates the price of a phone order. */
SSRHook.clientEndpoints.push({ name: "postWebPagesInfos", func: postWebPagesInfos })
export async function postWebPagesInfos(
    body: GetWebPagesInfos,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<null | (null | PostWebPagesInfos11Dto)[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/web/pages-infos`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useWebPagesInfos = SSRHook<
    [body: GetWebPagesInfos | null],
    null | (null | PostWebPagesInfos11Dto)[]
>("postWebPagesInfos", undefined, undefined, postWebPagesInfos, ["body"], undefined)
export type WebMenu<T0> = {
    /** The menu items to show in the.*/ items: WebMenuItem[]
}
SSRHook.clientEndpoints.push({ name: "getWebMenu", func: getWebMenu })
export async function getWebMenu(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<WebMenu<WebMenuItem>> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/web/menu`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useWebMenu = SSRHook<[], WebMenu<WebMenuItem>>(
    "getWebMenu",
    "WebMenu",
    undefined,
    getWebMenu,
    [],
    undefined
)
/** Items in the footer. */
export type WebFooter = {
    /** The items to show in the footer.*/ items: WebFooterItem[]
}
SSRHook.clientEndpoints.push({ name: "getWebFooter", func: getWebFooter })
export async function getWebFooter(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<WebFooter> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/web/footer`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useWebFooter = SSRHook<[], WebFooter>(
    "getWebFooter",
    "WebFooter",
    undefined,
    getWebFooter,
    [],
    undefined
)
export type GetWebPermissionsDto = {
    canEditWebsite: boolean
    /** Indicates what environment this is. Can be used to display a warning
in the UI if the user is in a non-production environment.*/
    environment: "production" | "staging" | "ci" | "local"
}
SSRHook.clientEndpoints.push({ name: "getWebPermissions", func: getWebPermissions })
export async function getWebPermissions(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetWebPermissionsDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/web/permissions`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetWebPermissionsError = Unauthorized | JWTPropertyMissing
export function IsGetWebPermissionsError(e: any): e is GetWebPermissionsError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Unauthorized" || e.type === "JWTPropertyMissing")
    )
}
export const useWebPermissions = SSRHook<[], GetWebPermissionsDto>(
    "getWebPermissions",
    "GetWebPermissionsDto",
    undefined,
    getWebPermissions,
    [],
    undefined
)
export type GetColorStylesDto = { styles: any }
SSRHook.clientEndpoints.push({ name: "getColorStyles", func: getColorStyles })
export async function getColorStyles(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetColorStylesDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/studio/color-styles`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useColorStyles = SSRHook<[], GetColorStylesDto>(
    "getColorStyles",
    "GetColorStylesDto",
    undefined,
    getColorStyles,
    [],
    undefined
)
